import de, { useCallback as H, createContext as _e, useContext as ue, useReducer as me, useRef as rt, useState as G, useEffect as Q, useMemo as at, forwardRef as Te } from "react";
import fe from "camelize-ts";
import Se from "snakecase-keys";
var zt, wt = { exports: {} }, St = {}, Zt, xt, kt = {};
function Pe() {
  return Zt || (Zt = 1, t = kt, process.env.NODE_ENV !== "production" && function() {
    var e = de, s = 60103, o = 60106;
    t.Fragment = 60107;
    var A = 60108, f = 60114, m = 60109, v = 60110, L = 60112, N = 60113, n = 60120, E = 60115, T = 60116, l = 60121, a = 60122, _ = 60117, u = 60129, S = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var y = Symbol.for;
      s = y("react.element"), o = y("react.portal"), t.Fragment = y("react.fragment"), A = y("react.strict_mode"), f = y("react.profiler"), m = y("react.provider"), v = y("react.context"), L = y("react.forward_ref"), N = y("react.suspense"), n = y("react.suspense_list"), E = y("react.memo"), T = y("react.lazy"), l = y("react.block"), a = y("react.server.block"), _ = y("react.fundamental"), y("react.scope"), y("react.opaque.id"), u = y("react.debug_trace_mode"), y("react.offscreen"), S = y("react.legacy_hidden");
    }
    var C = typeof Symbol == "function" && Symbol.iterator, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(R) {
      for (var D = arguments.length, M = new Array(D > 1 ? D - 1 : 0), k = 1; k < D; k++) M[k - 1] = arguments[k];
      (function(z, j, $) {
        var x = i.ReactDebugCurrentFrame, W = "";
        if (h) {
          var st = p(h.type), B = h._owner;
          W += function(w, et, ht) {
            var nt = "";
            if (et) {
              var Dt = et.fileName, ft = Dt.replace(d, "");
              if (/^index\./.test(ft)) {
                var Et = Dt.match(d);
                if (Et) {
                  var Kt = Et[1];
                  Kt && (ft = Kt.replace(d, "") + "/" + ft);
                }
              }
              nt = " (at " + ft + ":" + et.lineNumber + ")";
            } else ht && (nt = " (created by " + ht + ")");
            return `
    in ` + (w || "Unknown") + nt;
          }(st, h._source, B && p(B.type));
        }
        (W += x.getStackAddendum()) !== "" && (j += "%s", $ = $.concat([W]));
        var F = $.map(function(w) {
          return "" + w;
        });
        F.unshift("Warning: " + j), Function.prototype.apply.call(console[z], console, F);
      })("error", R, M);
    }
    var d = /^(.*)[\\\/]/, c = 1;
    function p(R) {
      if (R == null) return null;
      if (typeof R.tag == "number" && r("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof R == "function") return R.displayName || R.name || null;
      if (typeof R == "string") return R;
      switch (R) {
        case t.Fragment:
          return "Fragment";
        case o:
          return "Portal";
        case f:
          return "Profiler";
        case A:
          return "StrictMode";
        case N:
          return "Suspense";
        case n:
          return "SuspenseList";
      }
      if (typeof R == "object") switch (R.$$typeof) {
        case v:
          return "Context.Consumer";
        case m:
          return "Context.Provider";
        case L:
          return k = R, z = R.render, j = "ForwardRef", $ = z.displayName || z.name || "", k.displayName || ($ !== "" ? j + "(" + $ + ")" : j);
        case E:
          return p(R.type);
        case l:
          return p(R.render);
        case T:
          var D = (M = R)._status === c ? M._result : null;
          if (D) return p(D);
      }
      var M, k, z, j, $;
      return null;
    }
    var P = {};
    i.ReactDebugCurrentFrame;
    var h = null;
    function I(R) {
      h = R;
    }
    var U, O, K = i.ReactCurrentOwner, Y = Object.prototype.hasOwnProperty, Z = { key: !0, ref: !0, __self: !0, __source: !0 };
    function ut(R, D, M, k, z) {
      var j, $ = {}, x = null, W = null;
      for (j in M !== void 0 && (x = "" + M), function(F) {
        if (Y.call(F, "key")) {
          var w = Object.getOwnPropertyDescriptor(F, "key").get;
          if (w && w.isReactWarning) return !1;
        }
        return F.key !== void 0;
      }(D) && (x = "" + D.key), function(F) {
        if (Y.call(F, "ref")) {
          var w = Object.getOwnPropertyDescriptor(F, "ref").get;
          if (w && w.isReactWarning) return !1;
        }
        return F.ref !== void 0;
      }(D) && (W = D.ref, function(F) {
        typeof F.ref == "string" && K.current;
      }(D)), D) Y.call(D, j) && !Z.hasOwnProperty(j) && ($[j] = D[j]);
      if (R && R.defaultProps) {
        var st = R.defaultProps;
        for (j in st) $[j] === void 0 && ($[j] = st[j]);
      }
      if (x || W) {
        var B = typeof R == "function" ? R.displayName || R.name || "Unknown" : R;
        x && function(F, w) {
          var et = function() {
            U || (U = !0, r("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
          };
          et.isReactWarning = !0, Object.defineProperty(F, "key", { get: et, configurable: !0 });
        }($, B), W && function(F, w) {
          var et = function() {
            O || (O = !0, r("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
          };
          et.isReactWarning = !0, Object.defineProperty(F, "ref", { get: et, configurable: !0 });
        }($, B);
      }
      return function(F, w, et, ht, nt, Dt, ft) {
        var Et = { $$typeof: s, type: F, key: w, ref: et, props: ft, _owner: Dt, _store: {} };
        return Object.defineProperty(Et._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(Et, "_self", { configurable: !1, enumerable: !1, writable: !1, value: ht }), Object.defineProperty(Et, "_source", { configurable: !1, enumerable: !1, writable: !1, value: nt }), Object.freeze && (Object.freeze(Et.props), Object.freeze(Et)), Et;
      }(R, x, W, z, k, K.current, $);
    }
    var q, J = i.ReactCurrentOwner;
    function it(R) {
      h = R;
    }
    function ct(R) {
      return typeof R == "object" && R !== null && R.$$typeof === s;
    }
    function Tt() {
      if (J.current) {
        var R = p(J.current.type);
        if (R) return `

Check the render method of \`` + R + "`.";
      }
      return "";
    }
    i.ReactDebugCurrentFrame, q = !1;
    var It = {};
    function bt(R, D) {
      if (R._store && !R._store.validated && R.key == null) {
        R._store.validated = !0;
        var M = function(z) {
          var j = Tt();
          if (!j) {
            var $ = typeof z == "string" ? z : z.displayName || z.name;
            $ && (j = `

Check the top-level render call using <` + $ + ">.");
          }
          return j;
        }(D);
        if (!It[M]) {
          It[M] = !0;
          var k = "";
          R && R._owner && R._owner !== J.current && (k = " It was passed a child from " + p(R._owner.type) + "."), it(R), r('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', M, k), it(null);
        }
      }
    }
    function yt(R, D) {
      if (typeof R == "object") {
        if (Array.isArray(R)) for (var M = 0; M < R.length; M++) {
          var k = R[M];
          ct(k) && bt(k, D);
        }
        else if (ct(R)) R._store && (R._store.validated = !0);
        else if (R) {
          var z = function(x) {
            if (x === null || typeof x != "object") return null;
            var W = C && x[C] || x["@@iterator"];
            return typeof W == "function" ? W : null;
          }(R);
          if (typeof z == "function" && z !== R.entries) for (var j, $ = z.call(R); !(j = $.next()).done; ) ct(j.value) && bt(j.value, D);
        }
      }
    }
    function Lt(R) {
      var D, M = R.type;
      if (M != null && typeof M != "string") {
        if (typeof M == "function") D = M.propTypes;
        else {
          if (typeof M != "object" || M.$$typeof !== L && M.$$typeof !== E) return;
          D = M.propTypes;
        }
        if (D) {
          var k = p(M);
          (function(z, j, $, x, W) {
            var st = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var B in z) if (st(z, B)) {
              var F = void 0;
              try {
                if (typeof z[B] != "function") {
                  var w = Error((x || "React class") + ": " + $ + " type `" + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof z[B] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw w.name = "Invariant Violation", w;
                }
                F = z[B](j, B, x, $, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (et) {
                F = et;
              }
              !F || F instanceof Error || (I(W), r("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", x || "React class", $, B, typeof F), I(null)), F instanceof Error && !(F.message in P) && (P[F.message] = !0, I(W), r("Failed %s type: %s", $, F.message), I(null));
            }
          })(D, R.props, "prop", k, R);
        } else M.PropTypes === void 0 || q || (q = !0, r("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p(M) || "Unknown"));
        typeof M.getDefaultProps != "function" || M.getDefaultProps.isReactClassApproved || r("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Rt(R, D, M, k, z, j) {
      var $ = function(w) {
        return typeof w == "string" || typeof w == "function" || w === t.Fragment || w === f || w === u || w === A || w === N || w === n || w === S || typeof w == "object" && w !== null && (w.$$typeof === T || w.$$typeof === E || w.$$typeof === m || w.$$typeof === v || w.$$typeof === L || w.$$typeof === _ || w.$$typeof === l || w[0] === a);
      }(R);
      if (!$) {
        var x, W = "";
        (R === void 0 || typeof R == "object" && R !== null && Object.keys(R).length === 0) && (W += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), W += Tt(), R === null ? x = "null" : Array.isArray(R) ? x = "array" : R !== void 0 && R.$$typeof === s ? (x = "<" + (p(R.type) || "Unknown") + " />", W = " Did you accidentally export a JSX literal instead of a component?") : x = typeof R, r("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, W);
      }
      var st = ut(R, D, M, z, j);
      if (st == null) return st;
      if ($) {
        var B = D.children;
        if (B !== void 0) if (k) if (Array.isArray(B)) {
          for (var F = 0; F < B.length; F++) yt(B[F], R);
          Object.freeze && Object.freeze(B);
        } else r("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
        else yt(B, R);
      }
      return R === t.Fragment ? function(w) {
        for (var et = Object.keys(w.props), ht = 0; ht < et.length; ht++) {
          var nt = et[ht];
          if (nt !== "children" && nt !== "key") {
            it(w), r("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", nt), it(null);
            break;
          }
        }
        w.ref !== null && (it(w), r("Invalid attribute `ref` supplied to `React.Fragment`."), it(null));
      }(st) : Lt(st), st;
    }
    var Ot = function(R, D, M) {
      return Rt(R, D, M, !1);
    }, Ct = function(R, D, M) {
      return Rt(R, D, M, !0);
    };
    t.jsx = Ot, t.jsxs = Ct;
  }()), kt;
  var t;
}
var Ft = (xt || (xt = 1, process.env.NODE_ENV === "production" ? wt.exports = function() {
  if (zt) return St;
  zt = 1;
  var t = de, e = 60103;
  if (St.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var s = Symbol.for;
    e = s("react.element"), St.Fragment = s("react.fragment");
  }
  var o = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, A = Object.prototype.hasOwnProperty, f = { key: !0, ref: !0, __self: !0, __source: !0 };
  function m(v, L, N) {
    var n, E = {}, T = null, l = null;
    for (n in N !== void 0 && (T = "" + N), L.key !== void 0 && (T = "" + L.key), L.ref !== void 0 && (l = L.ref), L) A.call(L, n) && !f.hasOwnProperty(n) && (E[n] = L[n]);
    if (v && v.defaultProps) for (n in L = v.defaultProps) E[n] === void 0 && (E[n] = L[n]);
    return { $$typeof: e, type: v, key: T, ref: l, props: E, _owner: o.current };
  }
  return St.jsx = m, St.jsxs = m, St;
}() : wt.exports = Pe()), wt.exports);
const ro = () => ({ ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "46349299-7ec4-41d9-a0b5-1912980d56ba", OTEL_EXPORT_URL: "https://ingest.us.signoz.cloud:443", OTEL_SERVICE_NAME: "honeycomb", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" }), ve = (t) => {
  switch (t) {
    case "text/csv":
      return "csv";
    case "image/jpeg":
      return "jpeg";
    case "application/json":
      return "json";
    case "text/markdown":
      return "md";
    case "application/vnd.oasis.opendocument.presentation":
      return "odp";
    case "application/vnd.oasis.opendocument.spreadsheet":
      return "ods";
    case "image/png":
      return "png";
    case "application/pdf":
      return "pdg";
    case "application/vnd.ms-powerpoint":
      return "ppt";
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "pptx";
    case "application/vnd.rar":
      return "rar";
    case "application/rtf":
      return "rtf";
    case "application/x-tar":
      return "tar";
    case "text/plain":
      return "txt";
    case "application/vnd.ms-excel":
      return "xls";
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "xlsx";
    case "application/zip":
    case "application/x-zip-compressed":
      return "zip";
    default:
      return void console.warn("unsupported mime type", t);
  }
}, Gt = (t, e) => {
  let s, o = t;
  try {
    let A = e.split(".");
    for (A.length === 0 && (A = [e]); A.length > 0; ) {
      if (s = A.shift(), !s) return;
      if (Array.isArray(o[s])) {
        o = [];
        const f = A.splice(-1).join(".");
        for (let m = 0, v = t[s].length; m < v; m++) o.push(Gt(t[s][m], f));
      } else o = o[s];
    }
    return o;
  } catch (A) {
    return void console.error("unexpected error occurred while trying to find value from pointer", t, e, A);
  }
}, ao = (t, e, s) => {
  let o, A = -1;
  for (let f = 0, m = t?.length; f < m; f += 1) if (o = Gt(t[f], e), Array.isArray(o)) {
    if (o.indexOf(s) !== -1) {
      A = f;
      break;
    }
  } else if (o === s) {
    A = f;
    break;
  }
  return A;
}, ye = (t, e, s = !1) => {
  const o = [...t].sort((A, f) => {
    let m = Gt(A, e.toString()), v = Gt(f, e.toString());
    return typeof m == "string" && (m = m.toLocaleLowerCase()), typeof v == "string" && (v = v.toLocaleLowerCase()), m === v ? 0 : m < v ? -1 : 1;
  });
  return s ? o.reverse() : o;
};
var Bt, Jt, Wt, pt = {}, tt = {};
function mt() {
  if (Bt) return tt;
  Bt = 1;
  var t = tt.ValidationError = function(a, _, u, S, y, C) {
    if (Array.isArray(S) ? (this.path = S, this.property = S.reduce(function(r, d) {
      return r + v(d);
    }, "instance")) : S !== void 0 && (this.property = S), a && (this.message = a), u) {
      var i = u.$id || u.id;
      this.schema = i || u;
    }
    _ !== void 0 && (this.instance = _), this.name = y, this.argument = C, this.stack = this.toString();
  };
  t.prototype.toString = function() {
    return this.property + " " + this.message;
  };
  var e = tt.ValidatorResult = function(a, _, u, S) {
    this.instance = a, this.schema = _, this.options = u, this.path = S.path, this.propertyPath = S.propertyPath, this.errors = [], this.throwError = u && u.throwError, this.throwFirst = u && u.throwFirst, this.throwAll = u && u.throwAll, this.disableFormat = u && u.disableFormat === !0;
  };
  function s(a, _) {
    return _ + ": " + a.toString() + `
`;
  }
  function o(a) {
    typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, o), this.instance = a.instance, this.schema = a.schema, this.options = a.options, this.errors = a.errors;
  }
  e.prototype.addError = function(a) {
    var _;
    if (typeof a == "string") _ = new t(a, this.instance, this.schema, this.path);
    else {
      if (!a) throw new Error("Missing error detail");
      if (!a.message) throw new Error("Missing error message");
      if (!a.name) throw new Error("Missing validator type");
      _ = new t(a.message, this.instance, this.schema, this.path, a.name, a.argument);
    }
    if (this.errors.push(_), this.throwFirst) throw new o(this);
    if (this.throwError) throw _;
    return _;
  }, e.prototype.importErrors = function(a) {
    typeof a == "string" || a && a.validatorType ? this.addError(a) : a && a.errors && (this.errors = this.errors.concat(a.errors));
  }, e.prototype.toString = function(a) {
    return this.errors.map(s).join("");
  }, Object.defineProperty(e.prototype, "valid", { get: function() {
    return !this.errors.length;
  } }), tt.ValidatorResultError = o, o.prototype = new Error(), o.prototype.constructor = o, o.prototype.name = "Validation Error";
  var A = tt.SchemaError = function a(_, u) {
    this.message = _, this.schema = u, Error.call(this, _), typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, a);
  };
  A.prototype = Object.create(Error.prototype, { constructor: { value: A, enumerable: !1 }, name: { value: "SchemaError", enumerable: !1 } });
  var f = tt.SchemaContext = function(a, _, u, S, y) {
    this.schema = a, this.options = _, Array.isArray(u) ? (this.path = u, this.propertyPath = u.reduce(function(C, i) {
      return C + v(i);
    }, "instance")) : this.propertyPath = u, this.base = S, this.schemas = y;
  };
  f.prototype.resolve = function(a) {
    return l(this.base, a);
  }, f.prototype.makeChild = function(a, _) {
    var u = _ === void 0 ? this.path : this.path.concat([_]), S = a.$id || a.id;
    let y = l(this.base, S || "");
    var C = new f(a, this.options, u, y, Object.create(this.schemas));
    return S && !C.schemas[y] && (C.schemas[y] = a), C;
  };
  var m = tt.FORMAT_REGEXPS = { "date-time": /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/, date: /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/, time: /^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/, duration: /P(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S)|\d+(D|M(\d+D)?|Y(\d+M(\d+D)?)?)(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S))?|\d+W)/i, email: /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/, "idn-email": /^("(?:[!#-\[\]-\u{10FFFF}]|\\[\t -\u{10FFFF}])*"|[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*)@([!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*|\[[!-Z\^-\u{10FFFF}]*\])$/u, "ip-address": /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, ipv6: /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/, uri: /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/, "uri-reference": /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/, iri: /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/, "iri-reference": /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~-\u{10FFFF}]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~-\u{10FFFF}])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/u, uuid: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i, "uri-template": /(%[0-9a-f]{2}|[!#$&(-;=?@\[\]_a-z~]|\{[!#&+,./;=?@|]?(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?(,(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?)*\})*/iu, "json-pointer": /^(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*$/iu, "relative-json-pointer": /^\d+(#|(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*)$/iu, hostname: /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/, "host-name": /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/, "utc-millisec": function(a) {
    return typeof a == "string" && parseFloat(a) === parseInt(a, 10) && !isNaN(a);
  }, regex: function(a) {
    var _ = !0;
    try {
      new RegExp(a);
    } catch {
      _ = !1;
    }
    return _;
  }, style: /[\r\n\t ]*[^\r\n\t ][^:]*:[\r\n\t ]*[^\r\n\t ;]*[\r\n\t ]*;?/, color: /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/, phone: /^\+(?:[0-9] ?){6,14}[0-9]$/, alpha: /^[a-zA-Z]+$/, alphanumeric: /^[a-zA-Z0-9]+$/ };
  m.regexp = m.regex, m.pattern = m.regex, m.ipv4 = m["ip-address"], tt.isFormat = function(a, _, u) {
    if (typeof a == "string" && m[_] !== void 0) {
      if (m[_] instanceof RegExp) return m[_].test(a);
      if (typeof m[_] == "function") return m[_](a);
    } else if (u && u.customFormats && typeof u.customFormats[_] == "function") return u.customFormats[_](a);
    return !0;
  };
  var v = tt.makeSuffix = function(a) {
    return (a = a.toString()).match(/[.\s\[\]]/) || a.match(/^[\d]/) ? a.match(/^\d+$/) ? "[" + a + "]" : "[" + JSON.stringify(a) + "]" : "." + a;
  };
  function L(a, _, u, S) {
    typeof u == "object" ? _[S] = E(a[S], u) : a.indexOf(u) === -1 && _.push(u);
  }
  function N(a, _, u) {
    _[u] = a[u];
  }
  function n(a, _, u, S) {
    typeof _[S] == "object" && _[S] && a[S] ? u[S] = E(a[S], _[S]) : u[S] = _[S];
  }
  function E(a, _) {
    var u = Array.isArray(_), S = u && [] || {};
    return u ? (a = a || [], S = S.concat(a), _.forEach(L.bind(null, a, S))) : (a && typeof a == "object" && Object.keys(a).forEach(N.bind(null, a, S)), Object.keys(_).forEach(n.bind(null, a, _, S))), S;
  }
  function T(a) {
    return "/" + encodeURIComponent(a).replace(/~/g, "%7E");
  }
  tt.deepCompareStrict = function a(_, u) {
    if (typeof _ != typeof u) return !1;
    if (Array.isArray(_)) return !!Array.isArray(u) && _.length === u.length && _.every(function(C, i) {
      return a(_[i], u[i]);
    });
    if (typeof _ == "object") {
      if (!_ || !u) return _ === u;
      var S = Object.keys(_), y = Object.keys(u);
      return S.length === y.length && S.every(function(C) {
        return a(_[C], u[C]);
      });
    }
    return _ === u;
  }, tt.deepMerge = E, tt.objectGetPath = function(a, _) {
    for (var u, S = _.split("/").slice(1); typeof (u = S.shift()) == "string"; ) {
      var y = decodeURIComponent(u.replace(/~0/, "~").replace(/~1/g, "/"));
      if (!(y in a)) return;
      a = a[y];
    }
    return a;
  }, tt.encodePath = function(a) {
    return a.map(T).join("");
  }, tt.getDecimalPlaces = function(a) {
    var _ = 0;
    if (isNaN(a)) return _;
    typeof a != "number" && (a = Number(a));
    var u = a.toString().split("e");
    if (u.length === 2) {
      if (u[1][0] !== "-") return _;
      _ = Number(u[1].slice(1));
    }
    var S = u[0].split(".");
    return S.length === 2 && (_ += S[1].length), _;
  }, tt.isSchema = function(a) {
    return typeof a == "object" && a || typeof a == "boolean";
  };
  var l = tt.resolveUrl = function(a, _) {
    const u = new URL(_, new URL(a, "resolve://"));
    if (u.protocol === "resolve:") {
      const { pathname: S, search: y, hash: C } = u;
      return S + y + C;
    }
    return u.toString();
  };
  return tt;
}
var Xt, Qt, te, ee, Ht = {};
function Yt() {
  if (Xt) return Ht;
  Xt = 1;
  var t = mt();
  function e(s, o) {
    this.id = s, this.ref = o;
  }
  return Ht.SchemaScanResult = e, Ht.scan = function(s, o) {
    function A(N, n) {
      if (!n || typeof n != "object") return;
      if (n.$ref) {
        let a = t.resolveUrl(N, n.$ref);
        return void (L[a] = L[a] ? L[a] + 1 : 0);
      }
      var E = n.$id || n.id;
      let T = t.resolveUrl(N, E);
      var l = E ? T : N;
      if (l) {
        if (l.indexOf("#") < 0 && (l += "#"), v[l]) {
          if (!t.deepCompareStrict(v[l], n)) throw new Error("Schema <" + l + "> already exists with different definition");
          return v[l];
        }
        v[l] = n, l[l.length - 1] == "#" && (v[l.substring(0, l.length - 1)] = n);
      }
      f(l + "/items", Array.isArray(n.items) ? n.items : [n.items]), f(l + "/extends", Array.isArray(n.extends) ? n.extends : [n.extends]), A(l + "/additionalItems", n.additionalItems), m(l + "/properties", n.properties), A(l + "/additionalProperties", n.additionalProperties), m(l + "/definitions", n.definitions), m(l + "/patternProperties", n.patternProperties), m(l + "/dependencies", n.dependencies), f(l + "/disallow", n.disallow), f(l + "/allOf", n.allOf), f(l + "/anyOf", n.anyOf), f(l + "/oneOf", n.oneOf), A(l + "/not", n.not);
    }
    function f(N, n) {
      if (Array.isArray(n)) for (var E = 0; E < n.length; E++) A(N + "/" + E, n[E]);
    }
    function m(N, n) {
      if (n && typeof n == "object") for (var E in n) A(N + "/" + E, n[E]);
    }
    var v = {}, L = {};
    return A(s, o), new e(v, L);
  }, Ht;
}
function Re() {
  if (te) return Qt;
  te = 1;
  var t = function() {
    if (Wt) return Jt;
    Wt = 1;
    var n = mt(), E = n.ValidatorResult, T = n.SchemaError, l = { ignoreProperties: { id: !0, default: !0, description: !0, title: !0, additionalItems: !0, then: !0, else: !0, $schema: !0, $ref: !0, extends: !0 } }, a = l.validators = {};
    function _(i, r, d, c, p) {
      var P = r.throwError, h = r.throwAll;
      r.throwError = !1, r.throwAll = !1;
      var I = this.validateSchema(i, p, r, d);
      return r.throwError = P, r.throwAll = h, !I.valid && c instanceof Function && c(I), I.valid;
    }
    function u(i, r) {
      if (Object.hasOwnProperty.call(i, r)) return i[r];
      if (r in i) {
        for (; i = Object.getPrototypeOf(i); ) if (Object.propertyIsEnumerable.call(i, r)) return i[r];
      }
    }
    function S(i, r, d, c, p, P) {
      if (this.types.object(i) && (!r.properties || r.properties[p] === void 0)) if (r.additionalProperties === !1) P.addError({ name: "additionalProperties", argument: p, message: "is not allowed to have the additional property " + JSON.stringify(p) });
      else {
        var h = r.additionalProperties || {};
        typeof d.preValidateProperty == "function" && d.preValidateProperty(i, p, h, d, c);
        var I = this.validateSchema(i[p], h, d, c.makeChild(h, p));
        I.instance !== P.instance[p] && (P.instance[p] = I.instance), P.importErrors(I);
      }
    }
    a.type = function(i, r, d, c) {
      if (i === void 0) return null;
      var p = new E(i, r, d, c), P = Array.isArray(r.type) ? r.type : [r.type];
      if (!P.some(this.testType.bind(this, i, r, d, c))) {
        var h = P.map(function(I) {
          if (I) {
            var U = I.$id || I.id;
            return U ? "<" + U + ">" : I + "";
          }
        });
        p.addError({ name: "type", argument: h, message: "is not of a type(s) " + h });
      }
      return p;
    }, a.anyOf = function(i, r, d, c) {
      if (i === void 0) return null;
      var p = new E(i, r, d, c), P = new E(i, r, d, c);
      if (!Array.isArray(r.anyOf)) throw new T("anyOf must be an array");
      if (!r.anyOf.some(_.bind(this, i, d, c, function(I) {
        P.importErrors(I);
      }))) {
        var h = r.anyOf.map(function(I, U) {
          var O = I.$id || I.id;
          return O ? "<" + O + ">" : I.title && JSON.stringify(I.title) || I.$ref && "<" + I.$ref + ">" || "[subschema " + U + "]";
        });
        d.nestedErrors && p.importErrors(P), p.addError({ name: "anyOf", argument: h, message: "is not any of " + h.join(",") });
      }
      return p;
    }, a.allOf = function(i, r, d, c) {
      if (i === void 0) return null;
      if (!Array.isArray(r.allOf)) throw new T("allOf must be an array");
      var p = new E(i, r, d, c), P = this;
      return r.allOf.forEach(function(h, I) {
        var U = P.validateSchema(i, h, d, c);
        if (!U.valid) {
          var O = h.$id || h.id || h.title && JSON.stringify(h.title) || h.$ref && "<" + h.$ref + ">" || "[subschema " + I + "]";
          p.addError({ name: "allOf", argument: { id: O, length: U.errors.length, valid: U }, message: "does not match allOf schema " + O + " with " + U.errors.length + " error[s]:" }), p.importErrors(U);
        }
      }), p;
    }, a.oneOf = function(i, r, d, c) {
      if (i === void 0) return null;
      if (!Array.isArray(r.oneOf)) throw new T("oneOf must be an array");
      var p = new E(i, r, d, c), P = new E(i, r, d, c), h = r.oneOf.filter(_.bind(this, i, d, c, function(U) {
        P.importErrors(U);
      })).length, I = r.oneOf.map(function(U, O) {
        return U.$id || U.id || U.title && JSON.stringify(U.title) || U.$ref && "<" + U.$ref + ">" || "[subschema " + O + "]";
      });
      return h !== 1 && (d.nestedErrors && p.importErrors(P), p.addError({ name: "oneOf", argument: I, message: "is not exactly one from " + I.join(",") })), p;
    }, a.if = function(i, r, d, c) {
      if (i === void 0) return null;
      if (!n.isSchema(r.if)) throw new Error('Expected "if" keyword to be a schema');
      var p, P = _.call(this, i, d, c, null, r.if), h = new E(i, r, d, c);
      if (P) {
        if (r.then === void 0) return;
        if (!n.isSchema(r.then)) throw new Error('Expected "then" keyword to be a schema');
        p = this.validateSchema(i, r.then, d, c.makeChild(r.then)), h.importErrors(p);
      } else {
        if (r.else === void 0) return;
        if (!n.isSchema(r.else)) throw new Error('Expected "else" keyword to be a schema');
        p = this.validateSchema(i, r.else, d, c.makeChild(r.else)), h.importErrors(p);
      }
      return h;
    }, a.propertyNames = function(i, r, d, c) {
      if (this.types.object(i)) {
        var p = new E(i, r, d, c), P = r.propertyNames !== void 0 ? r.propertyNames : {};
        if (!n.isSchema(P)) throw new T('Expected "propertyNames" to be a schema (object or boolean)');
        for (var h in i) if (u(i, h) !== void 0) {
          var I = this.validateSchema(h, P, d, c.makeChild(P));
          p.importErrors(I);
        }
        return p;
      }
    }, a.properties = function(i, r, d, c) {
      if (this.types.object(i)) {
        var p = new E(i, r, d, c), P = r.properties || {};
        for (var h in P) {
          var I = P[h];
          if (I !== void 0) {
            if (I === null) throw new T('Unexpected null, expected schema in "properties"');
            typeof d.preValidateProperty == "function" && d.preValidateProperty(i, h, I, d, c);
            var U = u(i, h), O = this.validateSchema(U, I, d, c.makeChild(I, h));
            O.instance !== p.instance[h] && (p.instance[h] = O.instance), p.importErrors(O);
          }
        }
        return p;
      }
    }, a.patternProperties = function(i, r, d, c) {
      if (this.types.object(i)) {
        var p = new E(i, r, d, c), P = r.patternProperties || {};
        for (var h in i) {
          var I = !0;
          for (var U in P) {
            var O = P[U];
            if (O !== void 0) {
              if (O === null) throw new T('Unexpected null, expected schema in "patternProperties"');
              try {
                var K = new RegExp(U, "u");
              } catch {
                K = new RegExp(U);
              }
              if (K.test(h)) {
                I = !1, typeof d.preValidateProperty == "function" && d.preValidateProperty(i, h, O, d, c);
                var Y = this.validateSchema(i[h], O, d, c.makeChild(O, h));
                Y.instance !== p.instance[h] && (p.instance[h] = Y.instance), p.importErrors(Y);
              }
            }
          }
          I && S.call(this, i, r, d, c, h, p);
        }
        return p;
      }
    }, a.additionalProperties = function(i, r, d, c) {
      if (this.types.object(i)) {
        if (r.patternProperties) return null;
        var p = new E(i, r, d, c);
        for (var P in i) S.call(this, i, r, d, c, P, p);
        return p;
      }
    }, a.minProperties = function(i, r, d, c) {
      if (this.types.object(i)) {
        var p = new E(i, r, d, c);
        return Object.keys(i).length >= r.minProperties || p.addError({ name: "minProperties", argument: r.minProperties, message: "does not meet minimum property length of " + r.minProperties }), p;
      }
    }, a.maxProperties = function(i, r, d, c) {
      if (this.types.object(i)) {
        var p = new E(i, r, d, c);
        return Object.keys(i).length <= r.maxProperties || p.addError({ name: "maxProperties", argument: r.maxProperties, message: "does not meet maximum property length of " + r.maxProperties }), p;
      }
    }, a.items = function(i, r, d, c) {
      var p = this;
      if (this.types.array(i) && r.items !== void 0) {
        var P = new E(i, r, d, c);
        return i.every(function(h, I) {
          if (Array.isArray(r.items)) var U = r.items[I] === void 0 ? r.additionalItems : r.items[I];
          else U = r.items;
          if (U === void 0) return !0;
          if (U === !1) return P.addError({ name: "items", message: "additionalItems not permitted" }), !1;
          var O = p.validateSchema(h, U, d, c.makeChild(U, I));
          return O.instance !== P.instance[I] && (P.instance[I] = O.instance), P.importErrors(O), !0;
        }), P;
      }
    }, a.contains = function(i, r, d, c) {
      var p = this;
      if (this.types.array(i) && r.contains !== void 0) {
        if (!n.isSchema(r.contains)) throw new Error('Expected "contains" keyword to be a schema');
        var P = new E(i, r, d, c);
        return i.some(function(h, I) {
          return p.validateSchema(h, r.contains, d, c.makeChild(r.contains, I)).errors.length === 0;
        }) === !1 && P.addError({ name: "contains", argument: r.contains, message: "must contain an item matching given schema" }), P;
      }
    }, a.minimum = function(i, r, d, c) {
      if (this.types.number(i)) {
        var p = new E(i, r, d, c);
        return r.exclusiveMinimum && r.exclusiveMinimum === !0 ? i > r.minimum || p.addError({ name: "minimum", argument: r.minimum, message: "must be greater than " + r.minimum }) : i >= r.minimum || p.addError({ name: "minimum", argument: r.minimum, message: "must be greater than or equal to " + r.minimum }), p;
      }
    }, a.maximum = function(i, r, d, c) {
      if (this.types.number(i)) {
        var p = new E(i, r, d, c);
        return r.exclusiveMaximum && r.exclusiveMaximum === !0 ? i < r.maximum || p.addError({ name: "maximum", argument: r.maximum, message: "must be less than " + r.maximum }) : i <= r.maximum || p.addError({ name: "maximum", argument: r.maximum, message: "must be less than or equal to " + r.maximum }), p;
      }
    }, a.exclusiveMinimum = function(i, r, d, c) {
      if (typeof r.exclusiveMinimum != "boolean" && this.types.number(i)) {
        var p = new E(i, r, d, c);
        return i > r.exclusiveMinimum || p.addError({ name: "exclusiveMinimum", argument: r.exclusiveMinimum, message: "must be strictly greater than " + r.exclusiveMinimum }), p;
      }
    }, a.exclusiveMaximum = function(i, r, d, c) {
      if (typeof r.exclusiveMaximum != "boolean" && this.types.number(i)) {
        var p = new E(i, r, d, c);
        return i < r.exclusiveMaximum || p.addError({ name: "exclusiveMaximum", argument: r.exclusiveMaximum, message: "must be strictly less than " + r.exclusiveMaximum }), p;
      }
    };
    var y = function(i, r, d, c, p, P) {
      if (this.types.number(i)) {
        var h = r[p];
        if (h == 0) throw new T(p + " cannot be zero");
        var I = new E(i, r, d, c), U = n.getDecimalPlaces(i), O = n.getDecimalPlaces(h), K = Math.max(U, O), Y = Math.pow(10, K);
        return Math.round(i * Y) % Math.round(h * Y) != 0 && I.addError({ name: p, argument: h, message: P + JSON.stringify(h) }), I;
      }
    };
    function C(i, r, d) {
      var c, p = d.length;
      for (c = r + 1; c < p; c++) if (n.deepCompareStrict(i, d[c])) return !1;
      return !0;
    }
    return a.multipleOf = function(i, r, d, c) {
      return y.call(this, i, r, d, c, "multipleOf", "is not a multiple of (divisible by) ");
    }, a.divisibleBy = function(i, r, d, c) {
      return y.call(this, i, r, d, c, "divisibleBy", "is not divisible by (multiple of) ");
    }, a.required = function(i, r, d, c) {
      var p = new E(i, r, d, c);
      return i === void 0 && r.required === !0 ? p.addError({ name: "required", message: "is required" }) : this.types.object(i) && Array.isArray(r.required) && r.required.forEach(function(P) {
        u(i, P) === void 0 && p.addError({ name: "required", argument: P, message: "requires property " + JSON.stringify(P) });
      }), p;
    }, a.pattern = function(i, r, d, c) {
      if (this.types.string(i)) {
        var p = new E(i, r, d, c), P = r.pattern;
        try {
          var h = new RegExp(P, "u");
        } catch {
          h = new RegExp(P);
        }
        return i.match(h) || p.addError({ name: "pattern", argument: r.pattern, message: "does not match pattern " + JSON.stringify(r.pattern.toString()) }), p;
      }
    }, a.format = function(i, r, d, c) {
      if (i !== void 0) {
        var p = new E(i, r, d, c);
        return p.disableFormat || n.isFormat(i, r.format, this) || p.addError({ name: "format", argument: r.format, message: "does not conform to the " + JSON.stringify(r.format) + " format" }), p;
      }
    }, a.minLength = function(i, r, d, c) {
      if (this.types.string(i)) {
        var p = new E(i, r, d, c), P = i.match(/[\uDC00-\uDFFF]/g);
        return i.length - (P ? P.length : 0) >= r.minLength || p.addError({ name: "minLength", argument: r.minLength, message: "does not meet minimum length of " + r.minLength }), p;
      }
    }, a.maxLength = function(i, r, d, c) {
      if (this.types.string(i)) {
        var p = new E(i, r, d, c), P = i.match(/[\uDC00-\uDFFF]/g);
        return i.length - (P ? P.length : 0) <= r.maxLength || p.addError({ name: "maxLength", argument: r.maxLength, message: "does not meet maximum length of " + r.maxLength }), p;
      }
    }, a.minItems = function(i, r, d, c) {
      if (this.types.array(i)) {
        var p = new E(i, r, d, c);
        return i.length >= r.minItems || p.addError({ name: "minItems", argument: r.minItems, message: "does not meet minimum length of " + r.minItems }), p;
      }
    }, a.maxItems = function(i, r, d, c) {
      if (this.types.array(i)) {
        var p = new E(i, r, d, c);
        return i.length <= r.maxItems || p.addError({ name: "maxItems", argument: r.maxItems, message: "does not meet maximum length of " + r.maxItems }), p;
      }
    }, a.uniqueItems = function(i, r, d, c) {
      if (r.uniqueItems === !0 && this.types.array(i)) {
        var p = new E(i, r, d, c);
        return i.every(C) || p.addError({ name: "uniqueItems", message: "contains duplicate item" }), p;
      }
    }, a.dependencies = function(i, r, d, c) {
      if (this.types.object(i)) {
        var p = new E(i, r, d, c);
        for (var P in r.dependencies) if (i[P] !== void 0) {
          var h = r.dependencies[P], I = c.makeChild(h, P);
          if (typeof h == "string" && (h = [h]), Array.isArray(h)) h.forEach(function(O) {
            i[O] === void 0 && p.addError({ name: "dependencies", argument: I.propertyPath, message: "property " + O + " not found, required by " + I.propertyPath });
          });
          else {
            var U = this.validateSchema(i, h, d, I);
            p.instance !== U.instance && (p.instance = U.instance), U && U.errors.length && (p.addError({ name: "dependencies", argument: I.propertyPath, message: "does not meet dependency required by " + I.propertyPath }), p.importErrors(U));
          }
        }
        return p;
      }
    }, a.enum = function(i, r, d, c) {
      if (i === void 0) return null;
      if (!Array.isArray(r.enum)) throw new T("enum expects an array", r);
      var p = new E(i, r, d, c);
      return r.enum.some(n.deepCompareStrict.bind(null, i)) || p.addError({ name: "enum", argument: r.enum, message: "is not one of enum values: " + r.enum.map(String).join(",") }), p;
    }, a.const = function(i, r, d, c) {
      if (i === void 0) return null;
      var p = new E(i, r, d, c);
      return n.deepCompareStrict(r.const, i) || p.addError({ name: "const", argument: r.const, message: "does not exactly match expected constant: " + r.const }), p;
    }, a.not = a.disallow = function(i, r, d, c) {
      var p = this;
      if (i === void 0) return null;
      var P = new E(i, r, d, c), h = r.not || r.disallow;
      return h ? (Array.isArray(h) || (h = [h]), h.forEach(function(I) {
        if (p.testType(i, r, d, c, I)) {
          var U = I && (I.$id || I.id) || I;
          P.addError({ name: "not", argument: U, message: "is of prohibited type " + U });
        }
      }), P) : null;
    }, Jt = l;
  }(), e = mt(), s = Yt().scan, o = e.ValidatorResult, A = e.ValidatorResultError, f = e.SchemaError, m = e.SchemaContext, v = function n() {
    this.customFormats = Object.create(n.prototype.customFormats), this.schemas = {}, this.unresolvedRefs = [], this.types = Object.create(N), this.attributes = Object.create(t.validators);
  };
  function L(n) {
    var E = typeof n == "string" ? n : n.$ref;
    return typeof E == "string" && E;
  }
  v.prototype.customFormats = {}, v.prototype.schemas = null, v.prototype.types = null, v.prototype.attributes = null, v.prototype.unresolvedRefs = null, v.prototype.addSchema = function(n, E) {
    var T = this;
    if (!n) return null;
    var l = s(E || "/", n), a = E || n.$id || n.id;
    for (var _ in l.id) this.schemas[_] = l.id[_];
    for (var _ in l.ref) this.unresolvedRefs.push(_);
    return this.unresolvedRefs = this.unresolvedRefs.filter(function(u) {
      return T.schemas[u] === void 0;
    }), this.schemas[a];
  }, v.prototype.addSubSchemaArray = function(n, E) {
    if (Array.isArray(E)) for (var T = 0; T < E.length; T++) this.addSubSchema(n, E[T]);
  }, v.prototype.addSubSchemaObject = function(n, E) {
    if (E && typeof E == "object") for (var T in E) this.addSubSchema(n, E[T]);
  }, v.prototype.setSchemas = function(n) {
    this.schemas = n;
  }, v.prototype.getSchema = function(n) {
    return this.schemas[n];
  }, v.prototype.validate = function(n, E, T, l) {
    if (typeof E != "boolean" && typeof E != "object" || E === null) throw new f("Expected `schema` to be an object or boolean");
    T || (T = {});
    var a = E.$id || E.id;
    let _ = e.resolveUrl(T.base, a || "");
    if (!l) {
      (l = new m(E, T, [], _, Object.create(this.schemas))).schemas[_] || (l.schemas[_] = E);
      var u = s(_, E);
      for (var S in u.id) {
        var y = u.id[S];
        l.schemas[S] = y;
      }
    }
    var C;
    if (T.required && n === void 0) return (C = new o(n, E, T, l)).addError("is required, but is undefined"), C;
    if (!(C = this.validateSchema(n, E, T, l))) throw new Error("Result undefined");
    if (T.throwAll && C.errors.length) throw new A(C);
    return C;
  }, v.prototype.validateSchema = function(n, E, T, l) {
    var a = new o(n, E, T, l);
    if (typeof E == "boolean") E === !0 ? E = {} : E === !1 && (E = { type: [] });
    else if (!E) throw new Error("schema is undefined");
    if (E.extends) if (Array.isArray(E.extends)) {
      var _ = { schema: E, ctx: l };
      E.extends.forEach(this.schemaTraverser.bind(this, _)), E = _.schema, _.schema = null, _.ctx = null, _ = null;
    } else E = e.deepMerge(E, this.superResolve(E.extends, l));
    var u = L(E);
    if (u) {
      var S = this.resolve(E, u, l), y = new m(S.subschema, T, l.path, S.switchSchema, l.schemas);
      return this.validateSchema(n, S.subschema, T, y);
    }
    var C = T && T.skipAttributes || [];
    for (var i in E) if (!t.ignoreProperties[i] && C.indexOf(i) < 0) {
      var r = null, d = this.attributes[i];
      if (d) r = d.call(this, n, E, T, l);
      else if (T.allowUnknownAttributes === !1) throw new f("Unsupported attribute: " + i, E);
      r && a.importErrors(r);
    }
    if (typeof T.rewrite == "function") {
      var c = T.rewrite.call(this, n, E, T, l);
      a.instance = c;
    }
    return a;
  }, v.prototype.schemaTraverser = function(n, E) {
    n.schema = e.deepMerge(n.schema, this.superResolve(E, n.ctx));
  }, v.prototype.superResolve = function(n, E) {
    var T = L(n);
    return T ? this.resolve(n, T, E).subschema : n;
  }, v.prototype.resolve = function(n, E, T) {
    if (E = T.resolve(E), T.schemas[E]) return { subschema: T.schemas[E], switchSchema: E };
    let l = new URL(E, "thismessage::/").hash;
    var a = l && l.length && E.substr(0, E.length - l.length);
    if (!a || !T.schemas[a]) throw new f("no such schema <" + E + ">", n);
    var _ = e.objectGetPath(T.schemas[a], l.substr(1));
    if (_ === void 0) throw new f("no such schema " + l + " located in <" + a + ">", n);
    return { subschema: _, switchSchema: E };
  }, v.prototype.testType = function(n, E, T, l, a) {
    if (a !== void 0) {
      if (a === null) throw new f('Unexpected null in "type" keyword');
      if (typeof this.types[a] == "function") return this.types[a].call(this, n);
      if (a && typeof a == "object") {
        var _ = this.validateSchema(n, a, T, l);
        return _ === void 0 || !(_ && _.errors.length);
      }
      return !0;
    }
  };
  var N = v.prototype.types = {};
  return N.string = function(n) {
    return typeof n == "string";
  }, N.number = function(n) {
    return typeof n == "number" && isFinite(n);
  }, N.integer = function(n) {
    return typeof n == "number" && n % 1 == 0;
  }, N.boolean = function(n) {
    return typeof n == "boolean";
  }, N.array = function(n) {
    return Array.isArray(n);
  }, N.null = function(n) {
    return n === null;
  }, N.date = function(n) {
    return n instanceof Date;
  }, N.any = function(n) {
    return !0;
  }, N.object = function(n) {
    return n && typeof n == "object" && !Array.isArray(n) && !(n instanceof Date);
  }, Qt = v;
}
var $t = function() {
  if (ee) return pt;
  ee = 1;
  var t = pt.Validator = Re();
  return pt.ValidatorResult = mt().ValidatorResult, pt.ValidatorResultError = mt().ValidatorResultError, pt.ValidationError = mt().ValidationError, pt.SchemaError = mt().SchemaError, pt.SchemaScanResult = Yt().SchemaScanResult, pt.scan = Yt().scan, pt.validate = function(e, s, o) {
    return new t().validate(e, s, o);
  }, pt;
}();
const X = (t, e) => {
  if (!e) return console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: body missing` }), !1;
  try {
    if (!t.properties) return console.error({ name: "ValidationError", message: "Schema does not have any properties to validate", schema: t }), !1;
    const o = Object.entries(t.properties), A = Object.keys(e);
    if (o.length < A.length) return console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: body has more properties (${A.length}) than schema (${o.length})` }), !1;
  } catch (o) {
    return console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: unexpected error`, data: o }), !1;
  }
  const s = $t.validate(e, t, { required: !0 });
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: invalid body`, data: s.errors }), s.valid;
}, V = (t, e) => {
  const s = $t.validate(e, t);
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: invalid params`, data: s.errors }), s.valid;
}, ot = (t, e) => {
  const s = $t.validate(e, t);
  return s.valid || console.error({ name: "ValidationError", message: `unable to send request for ${t.id}: invalid query`, data: s.errors }), s.valid;
}, Mt = (t) => {
  if (!t) return "";
  const e = {};
  for (const [s, o] of Object.entries(t)) o && (e[s] = o.toString());
  return Object.keys(e).length ? `?${new URLSearchParams(e).toString()}` : "";
};
var Ne = ((t) => (t.IndexSizeError = "IndexSizeError", t.HierarchyRequestError = "HierarchyRequestError", t.WrongDocumentError = "WrongDocumentError", t.InvalidCharacterError = "InvalidCharacterError", t.NoModificationAllowedError = "NoModificationAllowedError", t.NotFoundError = "NotFoundError", t.NotSupportedError = "NotSupportedError", t.InvalidStateError = "InvalidStateError", t.InUseAttributeError = "InUseAttributeError", t.SyntaxError = "SyntaxError", t.InvalidModificationError = "InvalidModificationError", t.NamespaceError = "NamespaceError", t.InvalidAccessError = "InvalidAccessError", t.SecurityError = "SecurityError", t.NetworkError = "NetworkError", t.AbortError = "AbortError", t.URLMismatchError = "URLMismatchError", t.QuotaExceededError = "QuotaExceededError", t.TimeoutError = "TimeoutError", t.InvalidNodeTypeError = "InvalidNodeTypeError", t.DataCloneError = "DataCloneError", t.EncodingError = "EncodingError", t.NotReadableError = "NotReadableError", t.UnknownError = "UnknownError", t.ConstraintError = "ConstraintError", t.DataError = "DataError", t.TransactionInactiveError = "TransactionInactiveError", t.ReadOnlyError = "ReadOnlyError", t.VersionError = "VersionError", t.OperationError = "OperationError", t.NotAllowedError = "NotAllowedError", t))(Ne || {});
const Ue = (t, e) => t instanceof DOMException && (t.name === "AbortError" ? (console.warn(e && e.reason ? e.reason : t), !0) : (console.debug("unhandled DOM exception"), console.error(t), !1)), ge = (t) => H((e) => {
  t({ type: "SET_USER_FEATURES", data: e });
}, [t]), re = { type: "SET_USER_FEATURES", action: (t, e) => ({ ...t, features: e }) }, be = (t) => H((e) => {
  t({ type: "SET_USER_TENANCY", data: e });
}, [t]), ae = { type: "SET_USER_TENANCY", action: (t, e) => ({ ...t, tenant: e }) }, Le = (t) => H((e) => {
  t({ type: "SET_USER_TENANCY_SLUG", data: e });
}, [t]), ie = { type: "SET_USER_TENANCY_SLUG", action: (t, e) => ({ ...t, slug: e }) }, Oe = (t) => H((e) => {
  t({ type: "SET_USER_TOKEN", data: e });
}, [t]), se = { type: "SET_USER_TOKEN", action: (t, e) => ({ ...t, Token: e }) }, Ce = (t) => H((e) => {
  t({ type: "SET_USER", data: e });
}, [t]), oe = { type: "SET_USER", action: (t, e) => ({ ...t, ...e }) }, De = (t, e) => {
  switch (e.type) {
    case oe.type:
      return oe.action(t, e.data);
    case re.type:
      return re.action(t, e.data);
    case ae.type:
      return ae.action(t, e.data);
    case ie.type:
      return ie.action(t, e.data);
    case se.type:
      return se.action(t, e.data);
  }
}, ce = { tenant: "", slug: "", token: "", isLoggedIn: !1 }, Nt = () => {
  console.warn("unable to use state USER: state not setup");
}, He = { ...ce, setUser: Nt, setUserTenant: Nt, setUserTenantSlug: Nt, setUserToken: Nt, setUserFeatures: Nt }, he = _e(He), Ve = () => ue(he), io = ({ children: t }) => {
  const [e, s] = me(De, { ...ce }), o = { ...e, setUser: Ce(s), setUserTenant: be(s), setUserTenantSlug: Le(s), setUserToken: Oe(s), setUserFeatures: ge(s) };
  return Ft.jsx(he.Provider, { value: o, children: t });
}, gt = () => {
  const { token: t, slug: e } = Ve();
  return H(({ url: s, method: o, headers: A, body: f, signal: m, camel: v = !0, authRequired: L, tenantRequired: N }) => {
    if (L && (!t || N && !e)) {
      const E = { type: "process-error", status_code: -1, error_code: "ServiceNotReady", message: "unable to fetch data: token or tenant is not set" };
      return Promise.reject({ isError: !0, data: E });
    }
    const n = A ? { ...A } : {};
    return n.Accept || (n.Accept = "application/json"), n["Content-Type"] || (n["Content-Type"] = "application/json"), n["Content-Type"] === "multipart/form-data" && delete n["Content-Type"], n.Authorization = `Bearer ${t}`, n["x-curate-tenant-slug"] = e, n["x-request-id"] = window.crypto.randomUUID(), new Promise((E, T) => {
      const l = (a, _) => {
        const u = Ue(a, m), S = !_ || Fe(_?.status, a);
        if (u || S || console.error(a), a.status_code) {
          const y = { isError: !0, data: { ...a, type: "http-error" } };
          T(y);
        } else
          T({ isError: !0, data: a });
      };
      fetch(s, { method: o, headers: n, body: f === void 0 ? null : n["Content-Type"] === "application/json" ? JSON.stringify(Se(f)) : f }).then((a) => {
        const _ = /* @__PURE__ */ ((r) => (d) => {
          l(d, r);
        })(a);
        if (!a.ok) return void _({ status: a.status, statusText: a.statusText });
        const u = a.headers.get("Content-Type");
        if (!u)
          return void T({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "UnknownContentType", message: "unable to export planogram: missing content type from response", response: a } });
        const S = u.split(";")[0], y = (r) => {
          E({ isError: !1, data: v ? fe(r) : r });
        }, C = (r) => {
          E({ isError: !1, data: r });
        }, i = (r) => {
          E({ isError: !1, data: r });
        };
        switch (S) {
          case "text/csv":
          case "text/plain":
            a.text().then(C, T).catch(_);
            break;
          case "application/json":
            a.json().then(y, T).catch(_);
            break;
          case "application/zip":
            a.blob().then(i, T).catch(_);
            break;
          default:
            T({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "UnknownMediaType", message: `unable to export document assortment: media type ${S} is not supported`, response: a } });
            break;
        }
      }, l).catch(l);
    });
  }, [t, e]);
};
var g = ((t) => (t.GET = "GET", t.POST = "POST", t.PUT = "PUT", t.PATCH = "PATCH", t.DELETE = "DELETE", t))(g || {});
const so = ({ getEndpoint: t, preflightValidation: e, chunkSize: s = 6, onUpdate: o }) => {
  const A = gt(), f = rt(!1), [m, v] = G(!1), [L, N] = G(!1), [n, E] = G(), [T, l] = G(), a = rt([]), _ = rt([]), [u, S] = G([]), [y, C] = G(0), i = H((d) => {
    if (!d.length) return void console.warn("batch has nothing to process", u, d);
    const c = [];
    let p = !1, P = "", h = "";
    _.current = [];
    for (let I = 0, U = d.length; I < U; I++) {
      if (p = !e || e(d[I]), !p) {
        console.warn("batch request error: failed to pass preflightValidation", d[I]);
        break;
      }
      if (P = t(d[I]), !P) {
        p = !1, console.warn("batch request error: failed to create url", d[I]);
        break;
      }
      const O = new AbortController();
      _.current.push(O), h = Mt(d[I].query || {}), c.push({ ...d[I], url: h ? `${P}${h}` : P, method: g.GET, signal: O.signal });
    }
    c.length ? p ? (a.current = c.map((I) => A(I)), v(!0)) : console.warn("batch has invalid request") : console.debug("batch process does not have requests to send");
  }, [u, A, t, e]), r = H((d) => {
    d.length ? (N(!1), E(void 0), S(d), C(0)) : console.warn("batch request requires an list of params and/or queries");
  }, []);
  return Q(() => {
    if (!u || !u.length) return;
    const d = y, c = y + s, p = u.slice(d, c);
    p.length ? i(p) : console.warn("next batch empty", d, c, u);
  }, [u, y, s, i]), Q(() => {
    m && a.current.length && Promise.allSettled(a.current).then((d) => {
      const c = [], p = [];
      d.forEach((h) => {
        h.status !== "rejected" ? h.value.isError ? c.push(h.value) : p.push(h.value.data) : c.push(h.reason);
      }), c.length && (l(c), console.warn(c)), E((h) => h ? (o && o(p.slice(), h.slice()), h.concat(p)) : (o && o(p.slice(), []), p));
      const P = y + s;
      P < u.length ? C(P) : (N(!0), v(!1));
    }).catch((d) => {
      l([d]), N(!0), v(!1);
    });
  }, [u.length, y, s, m, o]), Q(() => (f.current = !0, () => {
    f.current = !1, _.current && _.current.length && _.current.forEach((d) => {
      d.abort();
    });
  }), []), [m, L, n, r, T];
}, Ge = ({ maxConcurrency: t = 8, getEndpoint: e, preflightValidation: s, method: o, headers: A, onFinish: f, onError: m, onResponse: v, onEmptyQueue: L }) => {
  const N = gt(), n = rt(!1), E = rt(/* @__PURE__ */ new Map()), T = rt(null), [l, a] = G(!1), [_, u] = G(0), S = H((r) => {
    m && m(r);
  }, [m]), y = H(() => {
    u((r) => r + 1);
  }, []), C = H(() => {
    if (E.current.size < t && T.current !== null) {
      const p = performance.now().toFixed(0).toString();
      E.current.set(p, { args: T.current.args }), T.current.resolve(!0), T.current = null;
    }
    if (!E.current.size && !T.current) return y(), void a(!1);
    const r = Array.from(E.current.keys());
    let d = 0;
    const c = [];
    for (a(!0); d < r.length && E.current.size > 0; ) {
      const p = r[d], P = E.current.get(p);
      if (d++, !P) {
        E.current.delete(p);
        continue;
      }
      if (P.abortController) continue;
      if (!(!s || s(P.args))) {
        S({ name: "InvalidPreFlightValidation", details: P.args }), E.current.delete(p);
        continue;
      }
      const h = e(P.args);
      if (!h) {
        S({ name: "InvalidUrl", details: P.args }), E.current.delete(p);
        continue;
      }
      const I = new AbortController(), U = N({ url: h, method: o, headers: A, signal: I.signal, body: P.args.body });
      c.push(U), E.current.set(p, { args: P.args, abortController: I }), U.finally(() => {
        f && f({ params: P.args.params }), E.current.delete(p);
      });
    }
    Promise.race(c).then((p) => {
      v && v(p), C();
    }, S);
  }, [t, S, y, s, e, N, o, A, f, v]), i = H((r) => new Promise((d) => {
    if (E.current.size < t) {
      const c = performance.now().toFixed(0).toString();
      return E.current.set(c, { args: r }), C(), void d(!0);
    }
    T.current = { resolve: d, args: r };
  }), [t, C]);
  return Q(() => {
    _ && L && (L(_), u(0));
  }, [L, _]), Q(() => (n.current = !0, () => {
    n.current = !1, E.current && E.current.size && (E.current.forEach((r) => {
      r.abortController && r.abortController.abort();
    }), E.current = /* @__PURE__ */ new Map());
  }), []), [l, i];
}, Me = (t, e, s, o) => {
  const A = t - e, f = Math.ceil(A / s);
  return f ? f - o > -1 ? o : f : -1;
}, we = ({ getEndpoint: t, pageLimit: e, chunkLimit: s, requestDelay: o, onUpdate: A, onComplete: f, onFailure: m }) => {
  const v = gt(), L = rt(!1), N = rt(), [n, E] = G(), [T, l] = G(!1), [a, _] = G(), [u, S] = G([]), y = H(() => {
    N.current && N.current.abort(), n && clearTimeout(n);
  }, [n]), C = H((i, r, d = !0) => {
    d && y();
    const c = (({ response: h, direction: I = "next" }) => {
      if (!Object.hasOwn(h, I) || h[I] === void 0 || h[I] === null) return console.warn(`unable to get offset value: response has no ${I} url`, h), -1;
      const U = h[I];
      if (U == null || typeof U != "string") return console.warn(`unable to get offset value: response has no ${I} url`, h), -1;
      const O = new URL(U).searchParams.get("offset");
      if (!O) return console.warn("unable to get offset value: offset param missing from response next url", h), -1;
      const K = parseInt(O);
      return isNaN(K) ? (console.warn("unable to get offset value: offset param is not a number", h, O), -1) : K;
    })({ response: i });
    if (l(!0), c === -1) {
      if (i.count !== i.results.length) return void console.warn("unable to send request chunks: no offset", i, c);
      const h = [...u, ...i.results];
      return S(h), A && A(i.results, h), f && f(), void l(!1);
    }
    const p = Me(i.count, c, e, s);
    if (p === -1) return console.warn("unable to get next chunk: no chunks left", i, p), void l(!1);
    const P = setTimeout(() => {
      const h = [];
      N.current = new AbortController(), _(void 0);
      for (let I = 0; I < p; I++) {
        const U = t(r);
        if (!U) {
          const Y = { isError: !0, data: { type: "process-error", status_code: -1, error_code: "MalformedURL", message: "unable to DRAIN: url is missing" } };
          console.warn(Y, r), _(Y), l(!1);
          break;
        }
        let O = "";
        Object.hasOwn(r, "query") && (O = Mt({ ...r.query, offset: I * e + c, limit: e }));
        const K = { ...r, url: `${U}${O}`, method: g.GET, signal: N.current.signal };
        h.push(v(K));
      }
      Promise.allSettled(h).then((I) => {
        if (!L.current) return;
        const U = [], O = [];
        let K;
        if (I.forEach((Z) => {
          Z.status === "rejected" ? U.push(Z.reason) : Z.status === "fulfilled" && (Z.value.isError ? U.push(Z.value) : (O.push(...Z.value.data.results), K = Z.value.data));
        }), !K) {
          const Z = { isError: !0, data: { type: "process-error", status_code: -1, error_code: "NoLastChunk", message: "unable to get next chunk: chunks malformed" } };
          return U.push(Z), _(U), void (m && m(U));
        }
        U.length && m && m(U);
        const Y = [...u, ...O];
        S(Y), A && A(O, Y), K.next ? C(K, r) : (f && f(), l(!1));
      });
    }, o);
    E(P);
  }, [y, u, s, v, t, f, m, A, e, o]);
  return Q(() => (L.current = !0, () => {
    L.current = !1, N.current?.abort();
  }), []), [T, u, C, a, y];
}, oo = ({ getEndpoint: t, preflightValidation: e, pageLimit: s = 100, chunkLimit: o = 2, requestDelay: A = 500, onUpdate: f, onComplete: m, onFailure: v }, L) => {
  const N = gt(), n = rt(!1), E = rt(), [T, l] = G(!1), [a, _] = G(!1), u = rt([]), [S, y] = G(), [C, i] = G(), [r, d] = G(0), c = H((q) => {
    n.current && (u.current.push(...q), f && f(q, u.current), y([...u.current]));
  }, [f]), p = H((q) => {
    if (n.current) return Array.isArray(q) || q.isError ? (v && v(q), console.debug(q), i(q), _(!0), void l(!1)) : void (q.isError || (console.error("DRAIN request handling non-error in Error handler", q), _(!0), l(!1)));
  }, [v]), P = H(() => {
    m && m(), _(!0), l(!1);
  }, [m]), [h, I, U, O, K] = we({ getEndpoint: t, pageLimit: s, chunkLimit: o, requestDelay: A, onUpdate: c, onComplete: P, onFailure: p }), Y = H(() => {
    E.current && E.current.abort(), K();
  }, [K]), Z = H((q) => (J) => {
    if (n.current) if (J.isError) p(J);
    else {
      if (u.current = [...J.data.results], d(J.data.count), y(u.current), !J.data.next) return _(!0), void l(!1);
      U(J.data, q);
    }
  }, [U, p]), ut = H((q, J = !0) => {
    if (J && Y(), l(!0), _(!1), d(0), u.current = [], !(!e || e(q)))
      return void p({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "PreflightValidation", message: "GET request did not pass preflight validation" } });
    const it = t(q);
    if (!it)
      return void p({ isError: !0, data: { type: "process-error", status_code: -1, error_code: "MalformedURL", message: "unable to DRAIN: url is missing" } });
    const ct = Mt(q.query), Tt = Z(q);
    E.current = new AbortController();
    const It = { ...q, url: ct ? `${it}${ct}` : it, method: g.GET, signal: E.current.signal };
    i(void 0), N(It).then(Tt, p).catch(p);
  }, [Y, N, t, p, Z, e]);
  return Q(() => {
    n.current = !0;
    const q = E.current?.abort;
    return () => {
      n.current = !1, q && q();
    };
  }, []), Q(() => {
    !L || T || S || C || O || ut(L);
  }, [O, S, ut, C, L, T]), [T || h, a, S, r, ut, C || O];
}, b = ({ getEndpoint: t, preflightValidation: e, formatQuery: s, onSuccess: o, onFailure: A, method: f, authRequired: m = !0, tenantRequired: v = !0, headers: L }, N) => {
  const n = gt(), E = rt(!1), T = rt(), [l, a] = G(!1), [_, u] = G(), [S, y] = G(), C = H((d) => {
    if (E.current) {
      if (d.isError) return A && A(d), y(d), void a(!1);
      if (o) {
        const c = o(d.data);
        u(c || d.data);
      } else u(d.data);
      a(!1);
    }
  }, [A, o]), i = H((d) => {
    console.debug(d), E.current && (d.isError && (y(d), A && A(d)), a(!1));
  }, [A]);
  H((d) => {
    T.current?.abort(d);
  }, []);
  const r = H((d, c = !0) => {
    const p = t(d);
    if (!p)
      return void console.warn({ error_code: "MalformedURL", message: "unable to send GET request: url is missing" }, d);
    const { params: P, query: h, body: I, ...U } = d;
    let O;
    if (typeof d.params != "boolean") {
      if (!(!e || e({ params: P, query: h, body: I })))
        return void console.warn({ error_code: "PreflightValidation", message: "GET request did not pass preflight validation" }, d);
      const Y = h ? s ? s(h) : h : void 0;
      O = { ...U, url: Y ? `${p}${Mt(Y)}` : p, method: f, body: I, authRequired: m, tenantRequired: v, headers: L };
    } else O = { url: p, method: f, authRequired: m, tenantRequired: v, headers: L };
    c && T.current?.abort();
    const K = new AbortController();
    O.signal = K.signal, u(void 0), y(void 0), T.current = K, a(!0), n(O).then(C, i).catch(i);
  }, [t, n, C, i, e, s, f, m, v, L]);
  return Q(() => {
    E.current = !0;
    const d = T.current?.abort;
    return () => {
      E.current = !1, d && d();
    };
  }, []), Q(() => {
    !N || l || _ || S || (typeof N.params != "boolean" || N.params) && r(N);
  }, [_, S, r, N, l]), at(() => [l, _, r, S], [l, _, r, S]);
}, Fe = (t, e) => t >= 200 && t <= 209 || t >= 300 && t <= 308 || (t >= 400 && t <= 429 ? (console.warn(e), !0) : t >= 500 && t <= 511 ? (console.error(e), !0) : (console.debug("unhandled HTTP Status"), console.error(e), !1)), Ye = ({ params: t }) => `https://platform.hivery.ai/api/v1/agent/assistants${t?.assistantId ? `/${t?.assistantId}` : ""}`, qe = { id: "ParamsGetAgentAssistants", type: "object", properties: { assistantId: { type: "string", required: !0 } }, required: !1 }, je = ({ params: t }) => V(qe, t), po = (t, e) => b({ ...e, method: g.GET, getEndpoint: Ye, preflightValidation: je }, t), $e = ({ params: t }) => {
  const e = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "46349299-7ec4-41d9-a0b5-1912980d56ba", OTEL_EXPORT_URL: "https://ingest.us.signoz.cloud:443", OTEL_SERVICE_NAME: "honeycomb", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  if (t?.threadId && t?.messageId) return `${e.AGENT_API}/threads/${t.threadId}/messages/${t.messageId}`;
}, Ke = { id: "ParamsGetAgentMessage", type: "object", properties: { threadId: { type: "string", required: !0 }, messageId: { type: "string", required: !0 } }, required: !1 }, ze = ({ params: t }) => V(Ke, t), no = (t, e) => b({ ...e, method: g.GET, getEndpoint: $e, preflightValidation: ze }, t), Ze = ({ params: t }) => {
  const e = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "46349299-7ec4-41d9-a0b5-1912980d56ba", OTEL_EXPORT_URL: "https://ingest.us.signoz.cloud:443", OTEL_SERVICE_NAME: "honeycomb", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  if (t?.threadId && t?.runId) return `${e.AGENT_API}/threads/${t.threadId}/runs/${t.runId}`;
}, xe = { id: "ParamsGetAgentRun", type: "object", properties: { threadId: { type: "string", required: !0 }, runId: { type: "string", required: !0 } }, required: !1 }, ke = ({ params: t }) => V(xe, t), Eo = (t, e) => b({ ...e, method: g.GET, getEndpoint: Ze, preflightValidation: ke }, t), Be = ({ params: t }) => `https://platform.hivery.ai/api/v1/agent/threads${t?.threadId ? `/${t?.threadId}` : ""}`, Je = { id: "ParamsGetAgentThreads", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, We = ({ params: t }) => V(Je, t), _o = (t, e) => b({ ...e, method: g.GET, getEndpoint: Be, preflightValidation: We }, t), Xe = ({ params: t }) => {
  const e = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "46349299-7ec4-41d9-a0b5-1912980d56ba", OTEL_EXPORT_URL: "https://ingest.us.signoz.cloud:443", OTEL_SERVICE_NAME: "honeycomb", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  if (t?.threadId) return `${e.AGENT_API}/threads/${t.threadId}/messages`;
}, Qe = { id: "ParamsListAgentMessages", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, tr = { id: "QueryListAgentMessages", type: "object", properties: { limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 } }, required: !1 }, er = ({ params: t, query: e }) => {
  const s = V(Qe, t);
  return s && ot(tr, e);
}, uo = (t, e) => b({ ...e, method: g.GET, getEndpoint: Xe, preflightValidation: er }, t), rr = { SINGLE: "single_agent_assistant" }, ar = { SCENARIO: "scenario" }, ir = { USER: "user", ASSISTANT: "assistant" }, co = { IN_PROGRESS: "in_progress", INCOMPLETE: "incomplete", COMPLETED: "completed" }, ho = { DIALOGUE: "dialogue", MONOLOGUE: "monologue", CHART: "chart" }, Ao = { NOMINAL: "nominal" }, lo = { BAR: "bar" }, Io = { SVG: "image/svg+xml", HTML: "image/html" }, mo = { QUEUED: "queued", IN_PROGRESS: "in_progress", FAILED: "failed", COMPLETED: "completed" }, sr = () => "https://platform.hivery.ai/api/v1/agent/assistants", or = { id: "BodyPostAgentAssistant", type: "object", properties: { assistantConfig: { type: "object", required: !0, additionalProperties: !1, properties: { assistantType: { type: "string", required: !0, enum: [rr.SINGLE] } } }, description: { type: "string" } }, required: !0 }, pr = ({ body: t }) => X(or, t), To = (t) => b({ ...t, method: g.POST, getEndpoint: sr, preflightValidation: pr }), nr = ({ params: t }) => {
  const e = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "46349299-7ec4-41d9-a0b5-1912980d56ba", OTEL_EXPORT_URL: "https://ingest.us.signoz.cloud:443", OTEL_SERVICE_NAME: "honeycomb", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  if (t?.threadId) return `${e.AGENT_API}/threads/${t.threadId}/messages`;
}, Er = { id: "ParamsPostAgentMessage", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, dr = { id: "BodyPostAgentMessage", type: "object", properties: { content: { type: "string", required: !0 }, role: { type: "string", required: !0, enum: [ir.USER] } }, required: !0 }, _r = ({ params: t, body: e }) => {
  const s = V(Er, t);
  return s && X(dr, e);
}, fo = (t) => b({ ...t, method: g.POST, getEndpoint: nr, preflightValidation: _r }), ur = ({ params: t }) => {
  const e = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "46349299-7ec4-41d9-a0b5-1912980d56ba", OTEL_EXPORT_URL: "https://ingest.us.signoz.cloud:443", OTEL_SERVICE_NAME: "honeycomb", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  if (t?.threadId) return `${e.AGENT_API}/threads/${t.threadId}/runs`;
}, cr = { id: "ParamsPostAgentRun", type: "object", properties: { threadId: { type: "string", required: !0 } }, required: !1 }, hr = { id: "ParamsPostAgentRun", type: "object", properties: { assistantId: { type: "string", required: !1 }, asyncMode: { type: "boolean", required: !1 } }, required: !1 }, Ar = ({ params: t, body: e }) => {
  const s = V(cr, t);
  return s && X(hr, e);
}, So = (t) => b({ ...t, method: g.POST, getEndpoint: ur, preflightValidation: Ar }), lr = () => "https://platform.hivery.ai/api/v1/agent/threads", Ir = { id: "BodyPostAgentThread", type: "object", properties: { scope: { type: "object", required: !0, additionalProperties: !1, properties: { scopeLevel: { type: "string", required: !0, enum: [ar.SCENARIO] }, tenantSlug: { type: "string", required: !0 }, projectId: { type: "number", required: !0 }, scenarioId: { type: "number", required: !0 } } } }, required: !0 }, mr = ({ body: t }) => X(Ir, t), Po = (t) => b({ ...t, method: g.POST, getEndpoint: lr, preflightValidation: mr }), Tr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/assortment`;
}, fr = { id: "ParamsGetAssortment", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Sr = ({ params: t }) => V(fr, t), vo = (t, e) => b({ ...e, method: g.GET, getEndpoint: Tr, preflightValidation: Sr }, t), Pr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/pods`;
}, vr = { id: "ParamsGetPODS", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, yr = ({ params: t, query: e }) => {
  const s = V(vr, t);
  if (!s) return s;
  const o = ["product_id", "store_id"];
  return e ? e.fields = e.fields ? [...o, ...e.fields] : o : e = { fields: o }, !0;
}, yo = (t, e) => b({ ...e, method: g.GET, getEndpoint: Pr, preflightValidation: yr }, t), Rr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/tasks/${t.taskId}/status`;
}, Nr = { id: "ParamsGetTasksStatus", type: "object", properties: { taskId: { type: "integer", required: !0 } }, required: !0 }, Ur = ({ params: t }) => V(Nr, t), gr = (t, e) => b({ ...e, method: g.GET, getEndpoint: Rr, preflightValidation: Ur }, t);
var Pt = ((t) => (t.COMPLETED = "COMPLETED", t.PENDING = "PENDING", t.CANCELLED = "CANCELLED", t.STARTED = "STARTED", t.ERROR = "ERROR", t))(Pt || {});
const Ae = () => {
  const t = rt(), [e, s] = G(!1), [o, A] = G(), [f, m] = G(), [v, L] = G(!1), N = H((_) => {
    if (!o || !o.params)
      return m({ isError: !0, data: { type: "process-error", error_code: "ValidationError", status_code: -1, message: "unable to continue polling task status: request params missing", response: _ } }), s(!1), _;
    switch (_.status) {
      case Pt.ERROR:
      case Pt.CANCELLED: {
        const u = { isError: !0, data: { type: "process-error", error_code: "ServerError", status_code: -1, message: `unable to continue polling task status: task resulted in ${_.status}: ${o.params.taskId}`, response: _ } };
        m(u), s(!1);
        break;
      }
      case Pt.COMPLETED:
        s(!1);
        break;
      case Pt.PENDING:
      case Pt.STARTED:
        L(!0);
    }
    return _;
  }, [o]), n = H((_) => {
    m(_), s(!1);
  }, []), [E, T, l] = gr(void 0, { onSuccess: N, onFailure: n }), a = H((_) => {
    s(!0), A(_), l(_);
  }, [l]);
  return Q(() => {
    v && o && (L(!1), t.current = setTimeout(() => {
      l(o);
    }, 5e3));
  }, [l, v, o]), Q(() => {
    const _ = t.current;
    return () => {
      _ && clearTimeout(_);
    };
  }, []), [e, T, a, f];
}, br = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/stores/export_assortment`;
}, Lr = { id: "ParamsExportAssortment", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Or = ({ params: t }) => V(Lr, t), Ro = () => {
  const [t, e] = G(!1), [s, o] = G(), [A, f] = G(), [m, v, L, N] = Ae(), n = H((u) => {
    if (typeof u == "string") o(u), e(!1);
    else if (u instanceof Object && Object.hasOwn(u, "taskId")) L({ params: { taskId: u.taskId } });
    else {
      const S = { isError: !0, data: { type: "process-error", error_code: "UnknownResponse", status_code: -1, message: "unknown response type from posting assortment request", response: u } };
      f(S), console.warn(S);
    }
    return u;
  }, [L]), E = H((u) => {
    f(u), e(!1);
  }, []), [T, l, a] = b({ method: g.POST, getEndpoint: br, preflightValidation: Or, onSuccess: n, onFailure: E }), _ = H((u) => {
    e(!0), a({ ...u, body: void 0 });
  }, [a]);
  return Q(() => {
    m || (N ? console.warn(N) : (o(v), e(!1)));
  }, [m, v, N]), at(() => [t, s, _, A], [A, s, t, _]);
};
var Cr = ((t) => (t.ADDED = "added", t.REMOVED = "removed", t.RETAINED = "retained", t.EXCLUDED = "excluded", t))(Cr || {});
const Dr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}`;
}, Hr = { id: "ParamsGetDocuments", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Vr = ({ params: t }) => V(Hr, t), No = (t, e) => b({ ...e, method: g.GET, getEndpoint: Dr, preflightValidation: Vr }, t), Gr = ({ params: t, query: e }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/workspaces/${t.workspaceId}/documents/summaries`;
}, Mr = { id: "ParamsGetDocumentsSummaries", type: "object", properties: { workspaceId: { type: "integer", required: !0 } }, required: !0 }, wr = ({ params: t, query: e }) => V(Mr, t), Uo = (t, e) => b({ ...e, method: g.GET, getEndpoint: Gr, preflightValidation: wr }, t);
var Fr = ((t) => (t.READY = "READY", t.BUSY = "BUSY", t))(Fr || {});
const Yr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/edit_requests/most_recent`;
}, qr = { id: "ParamsGetEditRequestsMostRecent", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, jr = ({ params: t }) => V(qr, t), $r = (t, e) => b({ ...e, method: g.GET, getEndpoint: Yr, preflightValidation: jr }, t);
var qt = ((t) => (t.pending = "PENDING", t.error = "ERROR", t.completed = "COMPLETED", t))(qt || {}), _t = ((t) => (t.drop = "DROP_POSITION", t.dropProduct = "DROP_PRODUCT", t.insert = "INSERT_POSITION", t.insertProduct = "INSERT_PRODUCT", t.move = "MOVE_POSITION", t.setFacings = "SET_POSITION_FACINGS", t.setProduct = "SET_POSITION_PRODUCT", t.swap = "SWAP_POSITION", t.swapProduct = "SWAP_PRODUCT", t.insertProductBulk = "INSERT_POSITION_BULK", t.dropPositionBulk = "DROP_POSITION_BULK", t))(_t || {});
const Kr = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/edit_requests`;
}, zr = { id: "ParamsPostEditRequestsCreate", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Zr = ({ params: t }) => V(zr, t), lt = () => {
  const [t, e] = G(!1), [s, o] = G(), [A, f] = G(), m = H((y) => {
    o(y), e(!1);
  }, []), v = H((y) => (e(!1), y), []), [L, N, n, E] = b({ method: g.POST, getEndpoint: Kr, preflightValidation: Zr, onFailure: m, onSuccess: v }), T = H((y) => {
    switch (y.status) {
      case qt.completed:
        if (!A || !A.body) {
          o({ isError: !0, data: { type: "process-error", error_code: "ValidationError", status_code: -1, message: "unable to create edit request: edit request data is missing" } }), e(!1);
          break;
        }
        n({ ...A, body: { ...A.body, version: y.version + 1 } }), e(!1);
        break;
      case qt.error:
        o({ isError: !0, data: { type: "process-error", error_code: "ServerError", status_code: -1, message: "unable to create edit request: most recent request encountered an error", response: y } }), e(!1);
        break;
    }
    return y;
  }, [n, A]), [l, a, _, u] = $r(void 0, { onFailure: m, onSuccess: T }), S = H((y) => {
    y.params ? (e(!0), o(void 0), f(y), _({ params: { documentId: y.params.documentId } })) : console.debug("unable to send edit request: params missing");
  }, [_]);
  return at(() => [t, N, S, s], [N, s, t, S]);
}, go = () => {
  const [t, e, s, o] = lt(), A = H(({ params: f, body: m }) => {
    if (!f || !m) return;
    const v = { version: 1, commandType: _t.drop, parameters: m };
    s({ params: f, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, A, o], [t, A, e, o]);
}, bo = () => {
  const [t, e, s, o] = lt(), A = H(({ params: f, body: m }) => {
    if (!f || !m) return;
    const v = { version: 1, commandType: _t.dropProduct, parameters: m };
    s({ params: f, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, A, o], [t, A, e, o]);
}, Lo = () => {
  const [t, e, s, o] = lt(), A = H(({ params: f, body: m }) => {
    if (!f || !m) return;
    const v = { version: 1, commandType: _t.insert, parameters: m };
    s({ params: f, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, A, o], [t, A, e, o]);
}, Oo = () => {
  const [t, e, s, o] = lt(), A = H(({ params: f, body: m }) => {
    if (!f || !m) return;
    const v = { version: 1, commandType: _t.insertProduct, parameters: m };
    s({ params: f, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, A, o], [t, A, e, o]);
}, Co = () => {
  const [t, e, s, o] = lt(), A = H(({ params: f, body: m }) => {
    if (!f || !m) return;
    const v = { version: 1, commandType: _t.move, parameters: m };
    s({ params: f, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, A, o], [t, A, e, o]);
}, Do = () => {
  const [t, e, s, o] = lt(), A = H(({ params: f, body: m }) => {
    if (!f || !m) return;
    const v = { version: 1, commandType: _t.setFacings, parameters: m };
    s({ params: f, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, A, o], [t, A, e, o]);
}, Ho = () => {
  const [t, e, s, o] = lt(), A = H(({ params: f, body: m }) => {
    if (!f || !m) return;
    const v = { version: 1, commandType: _t.swap, parameters: m };
    s({ params: f, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, A, o], [t, A, e, o]);
}, Vo = () => {
  const [t, e, s, o] = lt(), A = H(({ params: f, body: m }) => {
    if (!f || !m) return;
    const v = { version: 1, commandType: _t.swapProduct, parameters: m };
    s({ params: f, body: { version: -1, commands: [v] } });
  }, [s]);
  return at(() => [t, e, A, o], [t, A, e, o]);
}, xr = () => "https://platform.hivery.ai/api/v2/ssdi/test-auth", Go = (t, e) => b({ ...e, method: g.GET, getEndpoint: xr }, t), le = { MOVEMENT: "movement", PRODUCT: "product", PRODUCT_INNOVATIONS: "product_innovations", LOCATION: "location", LOCATION_INNOVATIONS: "location_innovations", LOCATION_PLANOGRAMS: "location_planograms", AVAILABILITY: "availability", PLANOGRAMS: "planograms" }, Mo = { PENDING: "pending", RESOLVING: "resolving", SUCCEEDED: "succeeded", FAILED: "failed", CANCELLED: "cancelled" }, kr = () => "https://platform.hivery.ai/api/v2/ssdi/files", Br = { id: "BodyPostFilesUpload", type: "object", properties: { kind: { type: "string", required: !0, enum: Object.values(le) }, name: { type: "string", required: !0 } }, required: !0 }, Jr = ({ body: t }) => X(Br, t), Wr = (t) => b({ ...t, method: g.POST, getEndpoint: kr, preflightValidation: Jr }), Xr = ({ params: t }) => {
  if (t) return `https://platform.hivery.ai/api/v2/ssdi/files/${t.id}/upload-complete`;
}, Qr = { id: "ParamsPostFilesUploadComplete", type: "object", properties: { id: { type: "string", required: !0 } }, required: !1 }, ta = { id: "BodyPostFilesUploadComplete", type: "object", properties: { filePartIds: { type: "array", required: !0, minItems: 1, items: { type: "string" }, additionalItems: !1 }, kind: { type: "string", required: !0, enum: Object.values(le) }, ext: { type: "string", required: !0 } }, required: !0 }, ea = ({ params: t, body: e }) => {
  const s = V(Qr, t);
  return s && X(ta, e);
}, ra = (t) => b({ ...t, method: g.POST, getEndpoint: Xr, preflightValidation: ea }), aa = ({ params: t }) => {
  if (t) return `https://platform.hivery.ai/api/v2/ssdi/files/${t.id}/upload-part/${t.part_number}`;
}, ia = { id: "ParamsPostFilesUploadPart", type: "object", properties: { id: { type: "string", required: !0 }, part_number: { type: "number", required: !0 } }, required: !1 }, sa = ({ params: t }) => V(ia, t), oa = (t) => {
  let e = { "Content-Type": "multipart/form-data" };
  return t && t.headers && (e = { ...t.headers, ...e }, delete t.headers), Ge({ ...t, method: g.POST, getEndpoint: aa, preflightValidation: sa, headers: e });
}, pa = () => "https://platform.hivery.ai/api/v1/curate/preferences", wo = (t = !0, e) => b({ ...e, method: g.GET, getEndpoint: pa, tenantRequired: !1 }, { params: t }), na = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/products/${t.productId}`;
}, Ea = { id: "ParamsGetCurateProduct", type: "object", properties: { productId: { type: "integer", required: !0 } }, required: !0 }, da = ({ params: t }) => {
  const e = V(Ea, t);
  return !!e || e;
}, Fo = (t, e) => b({ ...e, method: g.GET, getEndpoint: na, preflightValidation: da }, t), _a = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/scenarios/${t.scenarioId}/national-results`;
}, ua = { id: "ParamsGetCurateProductSummaries", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, ca = { id: "QueryGetCurateProductSummaries", type: "object", properties: { ordering: { type: "string", required: !0 } }, required: !0 }, ha = ({ params: t, query: e }) => {
  const s = V(ua, t);
  if (!s) return s;
  const o = ot(ca, e);
  return !!o || o;
}, Yo = (t, e) => b({ ...e, method: g.GET, getEndpoint: _a, preflightValidation: ha }, t), Aa = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/products/summaries`;
}, la = { id: "ParamsGetProductSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Ia = { id: "QueryGetProductSummaries", type: "object", properties: { group_by: { type: "string", required: !0, minLength: 1 } }, required: !0 }, ma = ({ params: t, query: e }) => {
  const s = V(la, t);
  if (!s) return s;
  const o = ot(Ia, e);
  return !!o || o;
}, qo = (t, e) => b({ ...e, method: g.GET, getEndpoint: Aa, preflightValidation: ma }, t), Ta = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/projects/${t.projectId}/products${t.productId ? `/${t.productId}` : ""}`;
}, fa = { id: "ParamsGetProducts", type: "object", properties: { projectId: { type: "integer", required: !0 }, productId: { type: "integer", required: !1 } }, required: !0 }, Sa = ({ params: t }) => V(fa, t), jo = (t, e) => b({ ...e, method: g.GET, getEndpoint: Ta, preflightValidation: Sa }, t), Pa = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/projects/${t.projectId}`;
}, va = { id: "ParamsDeleteProjects", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, ya = ({ params: t }) => V(va, t), $o = (t, e) => b({ ...e, method: g.DELETE, getEndpoint: Pa, preflightValidation: ya }, t), Ra = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/data-details`;
}, Na = { id: "ParamsGetProjectDataDetails", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Ua = ({ params: t }) => V(Na, t), Ko = (t, e) => b({ ...e, method: g.GET, getEndpoint: Ra, preflightValidation: Ua }, t), ga = () => "https://platform.hivery.ai/api/v1/curate/projects/file-upload-config", zo = (t = !0, e) => b({ ...e, method: g.GET, getEndpoint: ga }, { params: t });
var ba = ((t) => (t.SUCCESS = "success", t.PENDING = "pending", t.PROCESSING = "processing", t.FAILED = "failed", t))(ba || {}), Ut = ((t) => (t.PSA = "PSA", t.PTS = "PTS", t))(Ut || {});
const pe = { UPDATED_ASC: "+updated_on", UPDATED_DES: "-updated_on" }, La = ({ params: t }) => `https://platform.hivery.ai/api/v1/curate/projects${t?.projectId ? `/${t?.projectId}` : ""}`, Oa = { id: "ParamsGetProjects", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !1 }, Ca = { id: "QueryGetProjects", type: "object", properties: { search: { type: "string", required: !1 }, limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 }, ordering: { type: "string", required: !0, enum: [pe.UPDATED_ASC, pe.UPDATED_DES] } }, required: !1 }, Da = ({ params: t, query: e }) => t && Object.hasOwn(t, "projectId") ? V(Oa, t) : ot(Ca, e), Zo = (t, e) => b({ ...e, method: g.GET, getEndpoint: La, preflightValidation: Da }, t), Ha = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/projects/${t.projectId}`;
}, Va = { id: "ParamsPatchProject", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Ga = { id: "BodyPatchProject", type: "object", properties: { isArchive: { type: "boolean", required: !0 } } }, Ma = ({ params: t, body: e }) => {
  const s = V(Va, t);
  if (!s) return s;
  const o = X(Ga, e);
  return !!o || o;
}, xo = (t) => b({ ...t, method: g.PATCH, getEndpoint: Ha, preflightValidation: Ma }), wa = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/settings`;
}, Fa = { id: "ParamsPatchProjectSettings", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, Ya = { id: "BodyPatchProjectSettings", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 }, storesFile: { type: "string", required: !0, minLength: 1 }, productsFile: { type: "string", required: !0, minLength: 1 }, forecastsFile: { type: "string", required: !0, minLength: 1 }, suppliersFile: { type: "string", required: !0, minLength: 1 }, planogramsFile: { type: "string", required: !0, minLength: 0 }, planogramsFileFormat: { type: "string", enum: [Ut.PSA, Ut.PTS] }, planogramsFileNamingConvention: { type: "string", required: !0, minLength: 0 }, c13nsFile: { type: "string", required: !0, minLength: 0 }, changeC13nsFile: { type: "boolean", required: !0 } } }, qa = ({ params: t, body: e }) => {
  const s = V(Fa, t);
  if (!s) return s;
  const o = X(Ya, e);
  return !!o || o;
}, ko = (t) => b({ ...t, method: g.PATCH, getEndpoint: wa, preflightValidation: qa }), ne = { SPACE: "space", ASSORTMENT: "assortment" }, Bo = { FORCE_PODS_IN: "force_pods_in", FORCE_PODS_OUT: "force_pods_out", POD_PRESENCE: "pod_presence", TARGET_PODS: "target_pods", TARGET_QUANTITY_SOLD: "target_quantity_sold", TARGET_REVENUE: "target_revenue", TARGET_DISTRIBUTION: "target_distribution", TARGET_PRODUCT_SLOTTING: "target_product_slotting", PROTECT_PODS: "protect_pods", PARENT_RELATIONSHIP: "parent_relationship", LIMIT_ASSORTMENT_CHURN: "limit_assortment_churn", SPECIFY_ASSORTMENT_PRIORITY: "specify_assortment_priority" }, Jo = { ADJUST_AVAILABILITY: "adjust_availability", ADJUST_QUANITY_SOLD: "adjust_quantity_sold", ADJUST_REVENUE: "adjust_revenue", ADJUST_RANKING_PRIORITY: "adjust_ranking_priority", ADJUST_OBJECTIVE_VALUE: "adjust_objective_value" }, Wo = { SPECIFY_UNIT_CAPACITY: "specify_unit_capacity", SPECIFTY_CASE_CAPACITY: "specify_case_capacity", RESTRICT_UNSALEABLES: "restrict_unsaleables", SPECIFY_DOS_THRESHOLD: "specify_dos_threshold", DOS_BOOST: "dos_boost", CONTROL_FACINGS_FOR_ORIENTATION: "control_facings_for_orientation", LIMIT_SPACE_CHURN: "limit_space_churn", SPACE_ALLOCATION: "space_allocation" }, Xo = { MATCH_PLACEMENT_HIERARCHICAL: "match_placement_hierarchical", ALLOWABLE_FIXTURE_TYPES: "allowable_fixture_types", ORIENTATIONS_FOR_MERCH_STYLE: "orientations_for_merch_style", SPECIFY_HEIGHT_FOR_STYLE: "specify_height_for_style", MAXIMUM_STACK_HEIGHT_FOR_STYLE: "maximum_stack_height_for_style", ALLOWED_MERCHANDIZE_STYLES: "allowed_merchandise_styles", SPECIFY_PLACEMENT_RANGE: "specify_placement_range" }, Qo = { RELATIVE_POSITIONING: "relative_positioning", SINGLE_SHELF: "single_shelf", SINGLE_SEGMENT: "single_segment", SINGLE_LEVEL: "single_level", DISALLOW_PRESENCE: "disallow_presence", CHAIN_FLOW: "chain_flow", CONTROL_ALIGNMENT: "control_alignment", CONTROL_OVER_UNDERS: "control_over_unders" }, ja = () => "https://platform.hivery.ai/api/v1/curate/projects", $a = { id: "BodyPostProject", type: "object", properties: { algorithmTypes: { type: "array", required: !0, minItems: 1, items: { type: "string", enum: [ne.ASSORTMENT, ne.SPACE] }, additionalItems: !1 }, name: { type: "string", required: !0, minLength: 1 }, storesFile: { type: "string", required: !0, minLength: 1 }, productsFile: { type: "string", required: !0, minLength: 1 }, forecastsFile: { type: "string", required: !0, minLength: 1 }, suppliersFile: { type: "string", required: !0, minLength: 1 }, planogramsFile: { type: "string", required: !0, minLength: 0 }, planogramsFileFormat: { type: "string", enum: [Ut.PSA, Ut.PTS] }, planogramsFileNamingConvention: { type: "string", required: !0, minLength: 0 }, c13nsFile: { type: "string", required: !0, minLength: 0 }, c13nModelId: { type: "string", required: !0, minLength: 0 }, isCannibalisationOnly: { type: "boolean", required: !0 }, parameters: { type: "object", required: !0, properties: { podThresholds: { type: "string", required: !0, minLength: 0 }, productFlow: { type: "string", required: !0, minLength: 0 }, rankingWeights: { type: "string", required: !0, minLength: 0 } }, additionalProperties: !1 } } }, Ka = ({ body: t }) => X($a, t), tp = (t) => b({ ...t, method: g.POST, getEndpoint: ja, preflightValidation: Ka }), za = () => "https://platform.hivery.ai/api/v1/curate/constraint-types", Za = { id: "QueryGetConstraintTypes", type: "object", properties: { algorithm_types: { type: "string", required: !0 } }, required: !1 }, xa = ({ query: t }) => ot(Za, t), ep = (t, e) => b({ ...e, method: g.GET, getEndpoint: za, preflightValidation: xa }, t), ka = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios/${t.scenarioId}`;
}, Ba = { id: "ParamsDeleteScenario", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, Ja = ({ params: t }) => V(Ba, t), rp = (t, e) => b({ ...e, method: g.DELETE, getEndpoint: ka, preflightValidation: Ja }, t), Wa = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/reviews${t.reviewId ? `/${t.reviewId}` : ""}`;
}, Xa = { id: "ParamsGetReviews", type: "object", properties: { reviewId: { type: "integer", required: !1 } }, required: !1 }, Qa = ({ params: t }) => V(Xa, t), ap = (t, e) => b({ ...e, method: g.GET, getEndpoint: Wa, preflightValidation: Qa }, t), ti = () => "https://platform.hivery.ai/api/v1/curate/scenarios/aggregation-options", ip = (t = !0, e) => b({ ...e, method: g.GET, getEndpoint: ti }, { params: t }), ei = () => "https://platform.hivery.ai/api/v1/curate/scenarios/file-upload-config", sp = (t = !0, e) => b({ ...e, method: g.GET, getEndpoint: ei }, { params: t }), ri = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenario-groups${t.groupId ? `/${t.groupId}` : ""}`;
}, ai = { id: "ParamsGetScenarioGroups", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !1 } }, required: !0 }, ii = ({ params: t }) => V(ai, t), op = (t, e) => b({ ...e, method: g.GET, getEndpoint: ri, preflightValidation: ii }, t);
var si = ((t) => (t.SUCCESS = "success", t.SUCCESS_WITH_INFEASIBILITY = "success_with_inf", t.UNOPTIMISED = "unoptimised", t.PEDNING = "pending", t.PROCESSING = "processing", t.PROCESSING_UNPOLLABLE = "processing_unpollable", t.FAILED = "failed", t))(si || {}), oi = ((t) => (t.JOB_QUEUED = "job_queued", t.LOADING_DATA = "loading_data", t.SOLVING_MODEL = "solving_model", t.SAVING_RESULTS = "saving_results", t.PROCESSING = "processing", t.FAILED = "failed", t))(oi || {}), pi = ((t) => (t.RULE = "rules_based", t.IE = "interactive", t))(pi || {}), ni = ((t) => (t.IMPORT_PENDING = "import_pending", t.IMPORT_PROCESSING = "import_processing", t.IMPORT_FAILED = "import_failed", t.EDIT_PENDING = "edit_pending", t.EDIT_FAILED = "edit_failed", t.READY = "ready", t.SAVED = "saved", t))(ni || {});
const Vt = { PRODUCT_ASC: "product", PRODUCT_DES: "-product", UPC_ASC: "product_upc", UPC_DES: "-product_upc" }, Ei = { BRAND: "brand", SUB_BRAND: "subbrand", CATEGORY: "category", SUB_CATEGORY: "subcategory", SUB_SUB_CATEGORY: "subsubcategory", MANUFACTURER: "manufacturer", PACK_GROUP: "packgroup", PRODUCT_UPC: "product_upc", PRODUCT_GROUP: "product_group" }, di = ({ params: t, query: e }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/scenarios/${t.scenarioId}/national-results`;
}, _i = { id: "ParamsGetScenariosNationalResults", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, ui = { id: "QueryGetScenariosNationalResults", type: "object", properties: { ordering: { type: "string", required: !1, enum: [Vt.PRODUCT_ASC, Vt.PRODUCT_DES, Vt.UPC_ASC, Vt.UPC_DES] }, groupings: { type: "array", required: !1, items: { type: "string", uniqueItems: !0, enum: Object.entries(Ei).map((t, e) => e) } } } }, ci = ({ params: t, query: e }) => {
  const s = V(_i, t);
  if (!s) return s;
  const o = ot(ui, e);
  return !!o || o;
}, hi = (t) => {
  const e = {};
  return t.ordering && (e.ordering = t.ordering), t.groupBy && (e["group-by"] = t.groupBy.join(",")), e;
}, pp = (t, e) => b({ ...e, method: g.GET, getEndpoint: di, preflightValidation: ci, formatQuery: hi }, t), Ai = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios${t.scenarioId ? `/${t.scenarioId}` : ""}`;
}, li = { id: "ParamsGetScenarios", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !1 } }, required: !0 }, Ii = ({ params: t }) => V(li, t), np = (t, e) => b({ ...e, method: g.GET, getEndpoint: Ai, preflightValidation: Ii }, t), mi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios-base-core`;
}, Ti = { id: "ParamsGetScenariosBaseCore", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, fi = ({ params: t }) => V(Ti, t), Ep = (t, e) => b({ ...e, method: g.GET, getEndpoint: mi, preflightValidation: fi }, t), Si = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios/${t.reviewId}`;
}, Pi = { id: "ParamsPatchReview", type: "object", properties: { projectId: { type: "integer", required: !0 }, reviewId: { type: "integer", required: !0 } }, required: !0 }, vi = { id: "BodyPatchReview", type: "object", properties: { isArchived: { type: "boolean", required: !0 } } }, yi = ({ params: t, body: e }) => {
  const s = V(Pi, t);
  if (!s) return s;
  const o = X(vi, e);
  return !!o || o;
}, dp = (t) => b({ ...t, method: g.PATCH, getEndpoint: Si, preflightValidation: yi }), Ri = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios/${t.scenarioId}`;
}, Ni = { id: "ParamsPatchScenario", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, Ui = ({ params: t }) => V(Ni, t), _p = (t) => b({ ...t, method: g.PATCH, getEndpoint: Ri, preflightValidation: Ui }), gi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios/${t.scenarioId}/assign-group`;
}, bi = { id: "ParamsPatchScenarioAssignGroup", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, Li = { id: "BodyPatchScenarioGroupRename", type: "object", properties: { groupId: { type: "string", required: !0, minLength: 1 } } }, Oi = ({ params: t, body: e }) => {
  const s = V(bi, t);
  if (!s) return s;
  const o = X(Li, e);
  return !!o || o;
}, up = (t) => b({ ...t, method: g.PATCH, getEndpoint: gi, preflightValidation: Oi }), Ci = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenario-groups/${t.groupId}/archive`;
}, Di = { id: "ParamsPatchScenarioGroupArchive", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, Hi = ({ params: t }) => V(Di, t), cp = (t) => b({ ...t, method: g.PATCH, getEndpoint: Ci, preflightValidation: Hi }), Vi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenario-groups/${t.groupId}/undo-archive`;
}, Gi = { id: "ParamsPatchScenarioGroupArchiveUndo", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, Mi = ({ params: t }) => V(Gi, t), hp = (t) => b({ ...t, method: g.PATCH, getEndpoint: Vi, preflightValidation: Mi }), wi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenario-groups/${t.groupId}/rename`;
}, Fi = { id: "ParamsPatchScenarioGroupRename", type: "object", properties: { projectId: { type: "integer", required: !0 }, groupId: { type: "integer", required: !0 } }, required: !0 }, Yi = { id: "BodyPatchScenarioGroupRename", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 } } }, qi = ({ params: t, body: e }) => {
  const s = V(Fi, t);
  if (!s) return s;
  const o = X(Yi, e);
  return !!o || o;
}, Ap = (t) => b({ ...t, method: g.PATCH, getEndpoint: wi, preflightValidation: qi }), ji = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/scenarios/${t.scenarioId}/push_to_review`;
}, $i = { id: "ParamsPostReview", type: "object", properties: { scenarioId: { type: "integer", required: !0 } }, required: !0 }, Ki = { id: "BodyPostReview", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 } } }, zi = ({ params: t, body: e }) => {
  const s = V($i, t);
  if (!s) return s;
  const o = X(Ki, e);
  return !!o || o;
}, lp = (t) => b({ ...t, method: g.POST, getEndpoint: ji, preflightValidation: zi }), Zi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenario-groups`;
}, xi = { id: "ParamsPostScenarioGroups", type: "object", properties: { projectId: { type: "integer", required: !0 } }, required: !0 }, ki = { id: "BodyPostScenarioGroups", type: "object", properties: { name: { type: "string", required: !0, minLength: 1 }, orderIndex: { type: "number", required: !0 } } }, Bi = ({ params: t, body: e }) => {
  const s = V(xi, t);
  if (!s) return s;
  const o = X(ki, e);
  return !!o || o;
}, Ip = (t) => b({ ...t, method: g.POST, getEndpoint: Zi, preflightValidation: Bi }), Ji = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/clusters/${t.clusterId}/planograms`;
}, Wi = { id: "ParamsGetClusterPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 }, clusterId: { type: "integer", required: !0 } }, required: !0 }, Xi = ({ params: t }) => V(Wi, t), mp = (t, e) => b({ ...e, method: g.GET, getEndpoint: Ji, preflightValidation: Xi }, t), Qi = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/curate/scenarios/${t.scenarioId}/store-results/${t.storeId}`;
}, ts = { id: "ParamsGetCurateStoreProducts", type: "object", properties: { scenarioId: { type: "integer", required: !0 }, storeId: { type: "integer", required: !0 } }, required: !0 }, es = { id: "QueryGetCurateProductSummaries", type: "object", properties: { ordering: { type: "string", required: !0 } }, required: !0 }, rs = ({ params: t, query: e }) => {
  const s = V(ts, t);
  if (!s) return s;
  const o = ot(es, e);
  return !!o || o;
}, Tp = (t, e) => b({ ...e, method: g.GET, getEndpoint: Qi, preflightValidation: rs }, t), as = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v2/curate/projects/${t.projectId}/scenarios/${t.scenarioId}/store-list`;
}, is = { id: "ParamsGetCurateStores", type: "object", properties: { projectId: { type: "integer", required: !0 }, scenarioId: { type: "integer", required: !0 } }, required: !0 }, ss = { id: "QueryGetCurateProductSummaries", type: "object", properties: { offset: { type: "integer", required: !0 }, limit: { type: "integer", required: !0 }, ordering: { type: "string", required: !0 }, direction: { type: "string", required: !0 }, agg_vals: { type: "string", required: !0 }, aggregation: { type: "string", required: !0 } }, required: !0 }, os = ({ params: t, query: e }) => {
  const s = V(is, t);
  if (!s) return s;
  const o = ot(ss, e);
  return !!o || o;
}, fp = (t, e) => b({ ...e, method: g.GET, getEndpoint: as, preflightValidation: os }, t), ps = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/stores/kpi_summary`;
}, ns = { id: "ParamsGetStoreKpiSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Es = ({ params: t }) => V(ns, t), Sp = (t, e) => b({ ...e, method: g.GET, getEndpoint: ps, preflightValidation: Es }, t), ds = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/stores/${t.storeId}/planograms`;
}, _s = { id: "ParamsGetStoresPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 }, storeId: { type: "integer", required: !0 } }, required: !0 }, us = ({ params: t }) => V(_s, t), Pp = (t, e) => b({ ...e, method: g.GET, getEndpoint: ds, preflightValidation: us }, t), cs = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/stores/summaries`;
}, hs = { id: "ParamGetStoresSummaries", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, As = { id: "QueryGetStoreSummaries", type: "object", properties: { group_by: { type: "string", required: !0, minLength: 1 } }, required: !0 }, ls = ({ params: t, query: e }) => {
  const s = V(hs, t);
  if (!s) return s;
  const o = ot(As, e);
  return !!o || o;
}, vp = (t, e) => b({ ...e, method: g.GET, getEndpoint: cs, preflightValidation: ls }, t), Is = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/ie/documents/${t.documentId}/stores/planograms-export`;
}, ms = { id: "ParamsPostExportPlanograms", type: "object", properties: { documentId: { type: "integer", required: !0 } }, required: !0 }, Ts = ({ params: t }) => V(ms, t), yp = () => {
  const [t, e] = G(!1), [s, o] = G(), [A, f] = G(), [m, v, L, N] = Ae(), n = H((u) => {
    if (typeof u == "string") o(u), e(!1);
    else if (u instanceof Object && Object.hasOwn(u, "taskId")) L({ params: { taskId: u.taskId } });
    else {
      const S = { isError: !0, data: { type: "process-error", error_code: "UnknownResponse", status_code: -1, message: "unknown response type from posting assortment request", response: u } };
      f(S), console.warn(S);
    }
    return u;
  }, [L]), E = H((u) => {
    f(u), e(!1);
  }, []), [T, l, a] = b({ method: g.POST, getEndpoint: Is, preflightValidation: Ts, onSuccess: n, onFailure: E }), _ = H((u) => {
    e(!0), a({ ...u, body: void 0 });
  }, [a]);
  return Q(() => {
    m || (N ? console.warn(N) : (o(v), e(!1)));
  }, [m, v, N]), at(() => [t, s, _, A], [A, s, t, _]);
};
var fs = ((t) => (t.UNIT = "UNIT", t.TRAY = "TRAY", t.CASE = "CASE", t.DISPLAY = "DISPLAY", t.ALTERNATE = "ALTERNATE", t))(fs || {}), Ss = ((t) => (t.FIXTURE = "Fixture", t.SHELF = "Shelf", t.FLOATING = "FloatingShelf", t))(Ss || {});
const Ps = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/strategies/${t.strategy_id}/aggregation`;
}, vs = { id: "ParamsGetStrategyAggregation", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, ys = { id: "QueryGetStrategyAggregation", type: "object", properties: { aggregation: { type: "string", required: !0, minLength: 1 } }, required: !0 }, Rs = ({ params: t, query: e }) => {
  const s = V(vs, t);
  if (!s) return s;
  const o = ot(ys, e);
  return !!o || o;
}, Rp = (t, e) => b({ ...e, method: g.GET, getEndpoint: Ps, preflightValidation: Rs }, t);
var Ns = ((t) => (t.CALCULATE = "calculate", t.RESET = "reset", t.SAVE = "save", t))(Ns || {}), vt = ((t) => (t.NOT_READY = "not_ready", t.READY = "ready", t.PENDING = "pending", t.IN_PROGRESS = "in_progress", t.READ_ONLY = "read_only", t))(vt || {}), dt = ((t) => (t.NAME_ASC = "+name", t.NAME_DES = "-name", t.CREATED_ASC = "+created_on", t.CREATED_DES = "-created_on", t.UPDATED_ASC = "+updated_on", t.UPDATED_DES = "-updated_on", t.ARCHIVED_ASC = "+archived_on", t.ARCHIVED_DES = "-archived_on", t))(dt || {}), Us = ((t) => (t.CATEGORY = "category", t.SUB_CATEGORY = "sub_category", t.BRAND = "brand", t.SUB_BRAND = "sub_brand", t.PACK_GROUP = "pack_group", t))(Us || {});
const gs = ({ params: t, query: e }) => {
  const s = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "46349299-7ec4-41d9-a0b5-1912980d56ba", OTEL_EXPORT_URL: "https://ingest.us.signoz.cloud:443", OTEL_SERVICE_NAME: "honeycomb", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" };
  return typeof t == "boolean" ? `${s.STRATEGY_API}` : t || e ? e ? `${s.STRATEGY_API}` : t ? `${s.STRATEGY_API}/${t.strategy_id}` : void 0 : void 0;
}, bs = { id: "ParamsGetStrategies", type: "object", properties: { strategy_id: { type: "string", required: !1 } }, required: !1 }, Ls = { id: "QueryGetStrategies", type: "object", properties: { project_id: { type: "integer", required: !1 }, dataset_id: { type: "string", required: !1 }, model_id: { type: "string", required: !1 }, assortment_id: { type: "string", required: !1 }, kpi_id: { type: "string", required: !1 }, planogram_id: { type: "string", required: !1 }, state_status: { type: "string", required: !1, enum: [vt.NOT_READY, vt.READY, vt.PENDING, vt.IN_PROGRESS, vt.READ_ONLY] }, order_by: { type: "string", required: !1, enum: [dt.NAME_ASC, dt.NAME_DES, dt.CREATED_ASC, dt.CREATED_DES, dt.UPDATED_ASC, dt.UPDATED_DES, dt.ARCHIVED_ASC, dt.ARCHIVED_DES] }, limit: { type: "number", required: !1, minimum: 1, maximum: 100 }, offset: { type: "number", required: !1, minimum: 1 } }, required: !1 }, Os = ({ params: t, query: e }) => {
  let s = !0;
  if (typeof t == "boolean") return !0;
  if (s = V(bs, t), !s) return s;
  const o = ot(Ls, e);
  return !!o || o;
}, Np = (t, e) => {
  let s;
  return typeof t == "boolean" ? s = { params: t } : s = t, b({ ...e, method: g.GET, getEndpoint: gs, preflightValidation: Os }, s);
}, Cs = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/strategies/${t.strategy_id}/generate-data`;
}, Ds = { id: "ParamsPostStrategyGenerateData", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, Hs = { id: "BodyPostStrategyGenerateData", type: "object", properties: { stores: { type: "integer", required: !0 }, categories: { type: "integer", required: !0 }, sub_categories: { type: "integer", required: !0 }, brands: { type: "integer", required: !0 }, sub_brands: { type: "integer", required: !0 }, pack_groups: { type: "integer", required: !0 }, products: { type: "integer", required: !0 }, dist_min: { type: "integer", required: !0 }, dist_max: { type: "integer", required: !0 } }, required: !0 }, Vs = ({ params: t, body: e }) => {
  const s = V(Ds, t);
  if (!s) return s;
  const o = X(Hs, e);
  return !!o || o;
}, Up = (t) => b({ ...t, method: g.POST, getEndpoint: Cs, preflightValidation: Vs }), Gs = ({ params: t }) => {
  if (t)
    return `https://platform.hivery.ai/api/v1/strategies/${t.strategy_id}/ingest-data`;
}, Ms = { id: "ParamsPostStrategyIngestData", type: "object", properties: { strategy_id: { type: "string", required: !0 } }, required: !0 }, At = { type: "array", required: !0, minItems: 1, items: { type: "string" }, additionalItems: !1 }, ws = { id: "BodyPostStrategyIngestData", type: "object", properties: { descriptors: { type: "object", properties: { brands: At, subBrands: At, categories: At, subCategories: At, subSubCategories: At, manufacturers: At, packGroups: At, productGroups: At } }, products: { type: "array", required: !0, minItems: 1, items: { type: "object", properties: { id: { type: "integer", required: !0 }, upc: { type: "string", required: !0 }, name: { type: "string", required: !0 }, brand: { type: "string", required: !0 }, subBrand: { type: "string", required: !0 }, category: { type: "string", required: !0 }, subCategory: { type: "string", required: !0 }, subSubCategory: { type: "string", required: !0 }, packGroup: { type: "string", required: !0 }, productGroup: { type: "string", required: !0 }, storeIds: { type: "array", required: !0, items: { type: "integer" }, additionalItems: !1 }, podCount: { type: "integer", required: !0 }, weeklyMovement: { type: "number", required: !0 }, weeklyRevenue: { type: "number", required: !0 } } }, additionalItems: !1 } }, required: !0 }, Fs = ({ params: t, body: e }) => {
  const s = V(Ms, t);
  if (!s) return s;
  const o = X(ws, e);
  return !!o || o;
}, gp = (t) => b({ ...t, method: g.POST, getEndpoint: Gs, preflightValidation: Fs }), Ys = () => "https://platform.hivery.ai/api/v1/strategies/", qs = { id: "BodyPostStrategies", type: "object", properties: { project_id: { type: "integer", required: !0 }, scenario_id: { type: "integer", required: !0 }, name: { type: "string", required: !0, minLength: 1 } }, required: !0 }, js = ({ body: t }) => X(qs, t), bp = (t) => b({ ...t, method: g.POST, getEndpoint: Ys, preflightValidation: js }), $s = () => "https://platform.hivery.ai/api/v1/curate/users/customer-groups", Lp = (t = !0, e) => b({ ...e, method: g.GET, getEndpoint: $s }, { params: t }), Ks = () => "https://platform.hivery.ai/api/v1/curate/users/me", Op = (t = !0, e) => b({ ...e, method: g.GET, getEndpoint: Ks, tenantRequired: !1 }, { params: t }), zs = () => "https://platform.hivery.ai/api/v1/curate/users/customer-groups", Zs = { id: "BodyPatchUserCustomerGroup", type: "object", properties: { id: { type: "integer", required: !0 } } }, xs = ({ body: t }) => X(Zs, t), Cp = (t) => b({ ...t, method: g.PATCH, getEndpoint: zs, preflightValidation: xs }), ks = () => "https://platform.hivery.ai/api/v1/curate/passwordless/send-email", Bs = { id: "BodyPostLoginPasswordless", type: "object", properties: { email: { type: "string", required: !0, minLength: 1 } } }, Js = ({ body: t }) => X(Bs, t), Dp = (t) => b({ ...t, method: g.POST, getEndpoint: ks, preflightValidation: Js, authRequired: !1 }), Ws = ({ base_params: t, sendForm: e, maxChunks: s = 10, chunkSize: o = 2097152 }) => {
  const [A, f] = G(!1), [m, v] = G(), L = (N, n, E) => {
    const T = new FormData();
    return N.forEach((l, a) => {
      T.append(`${E + a}-${n}`, l);
    }), T;
  };
  return [A, H((N, n) => {
    const E = N.type, T = N.name, l = N.stream().getReader({ mode: "byob" });
    return v(Math.ceil(N.size / o / s)), new Promise((a, _) => {
      let u = new Uint8Array(o), S = new Uint8Array(o), y = 0, C = 0, i = [], r = 0, d = {};
      t || n ? (t && (d = { ...t }), n && (d = { ...n }), f(!0), l.read(u).then(async function c({ done: p, value: P }) {
        if (p) {
          const h = new Uint8Array(y);
          h.set(S.slice(0, y));
          const I = new Blob([h], { type: E });
          i.push(I), C++;
          const U = L(i, T, r * s), O = { params: { ...d, part_number: r }, body: U };
          return r++, console.debug(`readStream() complete. Total Form Count: ${r}`), await e(O), a({ readComplete: !0, partCount: C, formCount: r }), void f(!1);
        }
        if (u = new Uint8Array(o), y + P.byteLength > o) {
          const h = o - y, I = new Uint8Array(o);
          I.set(S), I.set(P.slice(0, h), h);
          const U = new Blob([I], { type: E });
          i.push(U), C++, S = new Uint8Array(o), S.set(P.slice(h + 1, P.byteLength)), y = P.byteLength - (h + 1);
        } else if (S.set(P, y), y += P.byteLength, y === o) {
          const h = new Blob([S], { type: E });
          i.push(h), C++, S = new Uint8Array(o), y = 0;
        }
        if (C === s) {
          const h = L(i, T, r * s), I = { params: { ...d, part_number: r }, body: h };
          r++, await e(I), C = 0, i = [];
        }
        return l.read(u).then(c);
      })) : _({ readComplete: !1, partCount: C, formCount: r, isError: !0, error: "Unable to build file forms: missing request params" });
    });
  }, [o, s, t, e]), m];
}, jt = 1048576, Ee = 1024 * jt, Ie = _e(null), Hp = () => {
  const t = ue(Ie);
  if (!t) throw new Error("useFileUploadContextSSDI must be used within a FileUploadSSDIProvider");
  return t;
}, Xs = Te(({ children: t, kind: e, ...s }, o) => {
  const [A, f] = G(null), [m, v] = G(null), [L, N] = G(!1), [n, E] = G(!1), [T, l] = G(!1), [a, _] = G(!1), [u, S] = G(!1), [y, C] = G([]), [i, r] = G(), [d, c] = G(0), p = rt(0), [P, h] = G(), I = at(() => {
    if (!A) return;
    const D = A.size;
    return D < jt ? `${(D / 1024).toFixed(2)}KB` : D < Ee ? `${(D / jt).toFixed(2)}MB` : `${(D / Ee).toFixed(2)}GB`;
  }, [A]), [U, O, K, Y] = Wr(), [Z, ut, q, J] = ra(), it = H(() => {
    c((D) => D + 1);
  }, []), ct = H(() => {
    if (!(Z || u || J)) if (i) if (O) if (m) {
      if (d === i.formCount) {
        const D = (performance.now() - p.current) / 1e3, M = ye(y, "part").map((k) => k.id);
        h(D), _(!0), l(!1), q({ params: { id: O.id }, body: { filePartIds: M, kind: O.kind, ext: m } });
      }
    } else console.debug("unable to process uploaded file: file ext not known");
    else console.debug("unable to process uploaded file empty queue: file meta data missing");
    else console.debug("unable to process uploaded file empty queue: file stats missing");
  }, [m, d, i, y, J, q, u, Z, O]), Tt = H((D) => {
    C((M) => D.isError ? M : [...M, { id: D.data.id, part: D.data.partNumber }]);
  }, []), [It, bt] = oa({ headers: { "X-File-Upload-Kind": e }, onFinish: it, onEmptyQueue: ct, onResponse: Tt }), [yt, Lt, Rt] = Ws({ sendForm: bt }), Ot = H((D) => {
    S(!1), _(!1), l(!1), E(!1), N(!1), r(void 0), c(0), h(void 0), p.current = 0;
    const M = ve(D.type);
    M && (v(M), f(D));
  }, []), Ct = H(() => {
    !L && A && (S(!1), _(!1), l(!1), E(!1), r(void 0), c(0), h(void 0), p.current = 0, N(!0), K({ body: { kind: e, name: A.name } }));
  }, [A, L, e, K]), R = at(() => ({ isFileInProgress: L, isFilePrepared: n, isFilePreparing: U, isFileUploaded: a, isFileUploading: T, isFileFinialized: u, isFileFinializing: Z, fileRequestCount: d, fileRequestExpectedCount: Rt, fileStats: i, fileSizeLabel: I, fileUploadDuration: P, setFile: Ot, sendFile: Ct, fileUploadError: Y || J }), [d, Rt, I, i, P, J, u, Z, L, n, U, a, T, Y, Ct, Ot]);
  return Q(() => {
    Y && N(!1);
  }, [Y]), Q(() => {
    !A || !O || yt || It || T || a || (p.current = performance.now(), Lt(A, { id: O.id }).then((D) => {
      r(D);
    }), h(void 0), l(!0), E(!0));
  }, [Lt, A, yt, Z, a, T, It, O]), Q(() => {
    J && N(!1);
  }, [J]), Q(() => {
    ut && (S(!0), N(!1));
  }, [ut]), Ft.jsx(Ie.Provider, { value: R, children: Ft.jsx("div", { ref: o, ...s, children: t }) });
});
Xs.displayName = "FileUploadSSDIProvider";
export {
  rr as AGENT_ASSISTANT_TYPES,
  Ao as AGENT_MESSAGE_CONTENT_CHART_DATA_FIELD_KINDS,
  lo as AGENT_MESSAGE_CONTENT_CHART_GEOMETRY_KINDS,
  Io as AGENT_MESSAGE_CONTENT_CHART_IMAGE_MIME_KINDS,
  ho as AGENT_MESSAGE_CONTENT_KINDS,
  ir as AGENT_MESSAGE_ROLES,
  co as AGENT_MESSAGE_STATUSES,
  mo as AGENT_RUN_STATUSES,
  ar as AGENT_THREAD_SCOPE_LEVELS,
  ne as ALGORITHM_TYPES,
  Cr as AssortedStatus,
  Bo as CONSTRAINT_KINDS_ASSORTMENT_CONTROLS,
  Jo as CONSTRAINT_KINDS_ASSORTMENT_OVERRIDES,
  Xo as CONSTRAINT_KINDS_SPACE_APPEARANCE,
  Wo as CONSTRAINT_KINDS_SPACE_LIMIT,
  Qo as CONSTRAINT_KINDS_SPACE_MERCHANDIZING,
  Fr as DocumentState,
  Ne as DomExceptionName,
  _t as EditRequestsCommandTypes,
  qt as EditRequestsStatuses,
  g as FetchMethod,
  Ie as FileUploadContextSSDI,
  Xs as FileUploadSSDIProvider,
  Ss as FixtureType,
  pe as GET_PROJECT_ORDER_BY,
  fs as MerchandiseStyle,
  Ut as PlanogramFileFormat,
  ba as ProjectImportStatuses,
  Ei as SCENARIO_NATIONAL_RESULTS_GROUPINGS,
  Vt as SCENARIO_NATIONAL_RESULTS_ORDER,
  oi as ScenarioOptimizationCodes,
  si as ScenarioOptimizationStatuses,
  ni as ScenarioReviewMetaStatuses,
  pi as ScenarioType,
  Ga as SchemaBodyPatchProject,
  Ya as SchemaBodyPatchProjectSettings,
  vi as SchemaBodyPatchReview,
  Li as SchemaBodyPatchScenarioAssignGroup,
  Yi as SchemaBodyPatchScenarioGroupRename,
  Zs as SchemaBodyPatchUserCustomerGroup,
  or as SchemaBodyPostAgentAssistant,
  dr as SchemaBodyPostAgentMessage,
  hr as SchemaBodyPostAgentRun,
  Ir as SchemaBodyPostAgentThread,
  Br as SchemaBodyPostFilesUpload,
  ta as SchemaBodyPostFilesUploadComplete,
  Bs as SchemaBodyPostLoginPasswordless,
  $a as SchemaBodyPostProject,
  Ki as SchemaBodyPostReview,
  ki as SchemaBodyPostScenarioGroups,
  qs as SchemaBodyPostStrategies,
  Hs as SchemaBodyPostStrategyGenerateData,
  ws as SchemaBodyPostStrategyIngestData,
  va as SchemaParamsDeleteProjects,
  Ba as SchemaParamsDeleteScenario,
  qe as SchemaParamsGetAgentAssistants,
  Ke as SchemaParamsGetAgentMessage,
  xe as SchemaParamsGetAgentRun,
  Je as SchemaParamsGetAgentThreads,
  fr as SchemaParamsGetAssortment,
  Wi as SchemaParamsGetClusterPlanograms,
  Ea as SchemaParamsGetCurateProduct,
  ua as SchemaParamsGetCurateProductSummaries,
  ts as SchemaParamsGetCurateStoreProducts,
  is as SchemaParamsGetCurateStores,
  Hr as SchemaParamsGetDocuments,
  Mr as SchemaParamsGetDocumentsSummaries,
  qr as SchemaParamsGetEditRequestsMostRecent,
  vr as SchemaParamsGetPODS,
  la as SchemaParamsGetProductSummaries,
  fa as SchemaParamsGetProducts,
  Na as SchemaParamsGetProjectDataDetails,
  Oa as SchemaParamsGetProjects,
  Xa as SchemaParamsGetReviews,
  ai as SchemaParamsGetScenarioGroups,
  li as SchemaParamsGetScenarios,
  Ti as SchemaParamsGetScenariosBaseCore,
  _i as SchemaParamsGetScenariosNationalResults,
  ns as SchemaParamsGetStoreKpiSummaries,
  _s as SchemaParamsGetStoresPlanograms,
  hs as SchemaParamsGetStoresSummaries,
  bs as SchemaParamsGetStrategies,
  vs as SchemaParamsGetStrategyAggregation,
  Nr as SchemaParamsGetTasksStatus,
  Qe as SchemaParamsListAgentMessages,
  Va as SchemaParamsPatchProject,
  Fa as SchemaParamsPatchProjectSettings,
  Pi as SchemaParamsPatchReview,
  Ni as SchemaParamsPatchScenario,
  bi as SchemaParamsPatchScenarioAssignGroup,
  Di as SchemaParamsPatchScenarioGroupArchive,
  Gi as SchemaParamsPatchScenarioGroupArchiveUndo,
  Fi as SchemaParamsPatchScenarioGroupRename,
  Er as SchemaParamsPostAgentMessage,
  cr as SchemaParamsPostAgentRun,
  zr as SchemaParamsPostEditRequestsCreate,
  Lr as SchemaParamsPostExportAssortment,
  ms as SchemaParamsPostExportPlanograms,
  Qr as SchemaParamsPostFilesUploadComplete,
  ia as SchemaParamsPostFilesUploadPart,
  $i as SchemaParamsPostReview,
  xi as SchemaParamsPostScenarioGroups,
  Ds as SchemaParamsPostStrategyGenerateData,
  Ms as SchemaParamsPostStrategyIngestData,
  Za as SchemaQueryGetConstraintTypess,
  ca as SchemaQueryGetCurateProductSummaries,
  es as SchemaQueryGetCurateStoreProducts,
  ss as SchemaQueryGetCurateStores,
  Ia as SchemaQueryGetProductSummaries,
  Ca as SchemaQueryGetProjects,
  ui as SchemaQueryGetScenariosNationalResults,
  As as SchemaQueryGetStoreSummaries,
  Ls as SchemaQueryGetStrategies,
  ys as SchemaQueryGetStrategyAggregation,
  tr as SchemaQueryListAgentMessages,
  dt as StrategiesOrderBy,
  Us as StrategyAggregationType,
  vt as StrategyStatusType,
  Ns as StrategyTaskType,
  Pt as TaskStatuses,
  le as UPLOAD_FILE_KINDS,
  Mo as UPLOAD_FILE_STATUSES,
  he as UserStateContext,
  He as UserStateContextInit,
  ce as UserStateInit,
  io as UserStateProvider,
  Mt as cleanQueryParams,
  Pa as endpointDeleteProjects,
  ka as endpointDeleteScenario,
  Ye as endpointGetAgentAssistants,
  $e as endpointGetAgentMessage,
  Ze as endpointGetAgentRun,
  Be as endpointGetAgentThreads,
  Tr as endpointGetAssortment,
  Ji as endpointGetClusterPlanograms,
  za as endpointGetConstraintTypess,
  na as endpointGetCurateProduct,
  _a as endpointGetCurateProductSummaries,
  Qi as endpointGetCurateStoreProducts,
  as as endpointGetCurateStores,
  $s as endpointGetCustomerGroups,
  Dr as endpointGetDocuments,
  Gr as endpointGetDocumentsSummaries,
  Yr as endpointGetEditRequestsMostRecent,
  Ks as endpointGetMe,
  Pr as endpointGetPODs,
  pa as endpointGetPreferences,
  Aa as endpointGetProductSummaries,
  Ta as endpointGetProducts,
  Ra as endpointGetProjectDataDetails,
  La as endpointGetProjects,
  ga as endpointGetProjectsFileUploadConfig,
  Wa as endpointGetReviews,
  ti as endpointGetScenarioAggregationOptions,
  ei as endpointGetScenarioFileUploadConfig,
  ri as endpointGetScenarioGroups,
  Ai as endpointGetScenarios,
  mi as endpointGetScenariosBaseCore,
  di as endpointGetScenariosNationalResults,
  ps as endpointGetStoreKpiSummaries,
  ds as endpointGetStoresPlanograms,
  gs as endpointGetStrategies,
  Ps as endpointGetStrategyAggregation,
  Rr as endpointGetTasksStatus,
  xr as endpointGetTestAuth,
  Xe as endpointListAgentMessages,
  Ha as endpointPatchProject,
  wa as endpointPatchProjectSettings,
  Si as endpointPatchReview,
  Ri as endpointPatchScenario,
  gi as endpointPatchScenarioAssignGroup,
  Ci as endpointPatchScenarioGroupArchive,
  Vi as endpointPatchScenarioGroupArchiveUndo,
  wi as endpointPatchScenarioGroupRename,
  zs as endpointPatchUserCustomerGroup,
  sr as endpointPostAgentAssistant,
  nr as endpointPostAgentMessage,
  ur as endpointPostAgentRun,
  lr as endpointPostAgentThread,
  Kr as endpointPostEditRequestsCreate,
  br as endpointPostExportAssortment,
  Is as endpointPostExportPlanograms,
  kr as endpointPostFilesUpload,
  Xr as endpointPostFilesUploadComplete,
  aa as endpointPostFilesUploadPart,
  ks as endpointPostLoginPasswordless,
  ja as endpointPostProject,
  ji as endpointPostReview,
  Zi as endpointPostScenarioGroups,
  Ys as endpointPostStrategies,
  Cs as endpointPostStrategyGenerateData,
  Gs as endpointPostStrategyIngestData,
  hi as formatQueryGetScenariosNationalResults,
  Me as getChunkSize,
  cs as getEndpointGetStoresSummaries,
  ro as getEnvConfig,
  ve as getFileExt,
  Ue as handleDomException,
  Fe as handleHTTPStatus,
  ao as indexByProp,
  ya as preflightValidationDeleteProjects,
  Ja as preflightValidationDeleteScenario,
  je as preflightValidationGetAgentAssistants,
  ze as preflightValidationGetAgentMessage,
  ke as preflightValidationGetAgentRun,
  We as preflightValidationGetAgentThreads,
  Sr as preflightValidationGetAssortment,
  Xi as preflightValidationGetClusterPlanograms,
  xa as preflightValidationGetConstraintTypess,
  da as preflightValidationGetCurateProduct,
  ha as preflightValidationGetCurateProductSummaries,
  rs as preflightValidationGetCurateStoreProducts,
  os as preflightValidationGetCurateStores,
  Vr as preflightValidationGetDocuments,
  wr as preflightValidationGetDocumentsSummaries,
  jr as preflightValidationGetEditRequestsMostRecent,
  yr as preflightValidationGetPODs,
  ma as preflightValidationGetProductSummaries,
  Sa as preflightValidationGetProducts,
  Ua as preflightValidationGetProjectDataDetails,
  Da as preflightValidationGetProjects,
  Qa as preflightValidationGetReviews,
  ii as preflightValidationGetScenarioGroups,
  Ii as preflightValidationGetScenarios,
  fi as preflightValidationGetScenariosBaseCore,
  ci as preflightValidationGetScenariosNationalResults,
  Es as preflightValidationGetStoreKpiSummaries,
  ls as preflightValidationGetStoreSummaries,
  us as preflightValidationGetStoresPlanograms,
  Os as preflightValidationGetStrategies,
  Rs as preflightValidationGetStrategyAggregation,
  Ur as preflightValidationGetTasksStatus,
  er as preflightValidationListAgentMessages,
  Ma as preflightValidationPatchProject,
  qa as preflightValidationPatchProjectSettings,
  yi as preflightValidationPatchReview,
  Ui as preflightValidationPatchScenario,
  Oi as preflightValidationPatchScenarioAssignGroup,
  Hi as preflightValidationPatchScenarioGroupArchive,
  Mi as preflightValidationPatchScenarioGroupArchiveUndo,
  qi as preflightValidationPatchScenarioGroupRename,
  xs as preflightValidationPatchUserCustomerGroup,
  pr as preflightValidationPostAgentAssistant,
  _r as preflightValidationPostAgentMessage,
  Ar as preflightValidationPostAgentRun,
  mr as preflightValidationPostAgentThread,
  Zr as preflightValidationPostEditRequestsCreate,
  Or as preflightValidationPostExportAssortment,
  Ts as preflightValidationPostExportPlanograms,
  Jr as preflightValidationPostFilesUpload,
  ea as preflightValidationPostFilesUploadComplete,
  sa as preflightValidationPostFilesUploadPart,
  Js as preflightValidationPostLoginPasswordless,
  Ka as preflightValidationPostProject,
  zi as preflightValidationPostReview,
  Bi as preflightValidationPostScenarioGroups,
  js as preflightValidationPostStrategies,
  Vs as preflightValidationPostStrategyGenerateData,
  Fs as preflightValidationPostStrategyIngestData,
  oe as setUser,
  re as setUserFeatures,
  ae as setUserTenant,
  ie as setUserTenantSlug,
  se as setUserToken,
  ye as sortByProp,
  $o as useDeleteProject,
  rp as useDeleteScenario,
  gt as useFetch,
  so as useFetchBatch,
  Ge as useFetchConcurrentAsyc,
  oo as useFetchDrain,
  b as useFetchRequest,
  Ws as useFileChunkFormBuilder,
  Hp as useFileUploadContextSSDI,
  po as useGetAgentAssistants,
  no as useGetAgentMessage,
  Eo as useGetAgentRun,
  _o as useGetAgentThreads,
  vo as useGetAssortments,
  we as useGetChunk,
  mp as useGetClusterPlanograms,
  ep as useGetConstraintTypes,
  Fo as useGetCurateProduct,
  Yo as useGetCurateProductSummaries,
  Tp as useGetCurateStoreProducts,
  fp as useGetCurateStores,
  Lp as useGetCustomerGroups,
  No as useGetDocuments,
  Uo as useGetDocumentsSummaries,
  $r as useGetEditRequestsMostRecent,
  Op as useGetMe,
  yo as useGetPODs,
  wo as useGetPreferences,
  qo as useGetProductSummaries,
  jo as useGetProducts,
  Ko as useGetProjectDataDetails,
  Zo as useGetProjects,
  zo as useGetProjectsFileUploadConfig,
  ap as useGetReviews,
  ip as useGetScenarioAggregationOptions,
  sp as useGetScenarioFileUploadConfig,
  op as useGetScenarioGroups,
  np as useGetScenarios,
  Ep as useGetScenariosBaseCore,
  pp as useGetScenariosNationalResults,
  Sp as useGetStoreKpiSummaries,
  Pp as useGetStoresPlanograms,
  vp as useGetStoresSummaries,
  Np as useGetStrategies,
  Rp as useGetStrategyAggregation,
  gr as useGetTasksStatus,
  Go as useGetTestAuth,
  uo as useListAgentMessages,
  xo as usePatchProject,
  ko as usePatchProjectSettings,
  dp as usePatchReview,
  _p as usePatchScenario,
  up as usePatchScenarioAssignGroup,
  cp as usePatchScenarioGroupArchive,
  hp as usePatchScenarioGroupArchiveUndo,
  Ap as usePatchScenarioGroupRename,
  Cp as usePatchUserCustomerGroup,
  Ae as usePollTaskStatus,
  To as usePostAgentAssistant,
  fo as usePostAgentMessage,
  So as usePostAgentRun,
  Po as usePostAgentThread,
  go as usePostEditRequestDropPosition,
  bo as usePostEditRequestDropProduct,
  Lo as usePostEditRequestInsertPosition,
  Oo as usePostEditRequestInsertProduct,
  Co as usePostEditRequestMovePosition,
  Do as usePostEditRequestSetFacings,
  Ho as usePostEditRequestSwapPosition,
  Vo as usePostEditRequestSwapProduct,
  lt as usePostEditRequestsCreate,
  Ro as usePostExportAssortment,
  yp as usePostExportPlanograms,
  Wr as usePostFilesUpload,
  ra as usePostFilesUploadComplete,
  oa as usePostFilesUploadPart,
  Dp as usePostLoginPasswordless,
  tp as usePostProject,
  lp as usePostReview,
  Ip as usePostScenarioGroups,
  bp as usePostStrategies,
  Up as usePostStrategyGenerateData,
  gp as usePostStrategyIngestData,
  Ce as useSetUser,
  ge as useSetUserFeatures,
  be as useSetUserTenant,
  Le as useSetUserTenantSlug,
  Oe as useSetUserToken,
  Ve as useUserState,
  De as userReducer,
  X as validateBody,
  V as validateParams,
  ot as validateQuery,
  Gt as valueByProp
};
//# sourceMappingURL=api.js.map
